// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS Custom Properties for theming */
:root {
  /* New Theme Variables (from template) */
  --bg-color: #f4f4f5;
  --card-bg: #ffffff;
  --sidebar-bg: #ffffff;
  --text-main: #18181b;
  --text-muted: #71717a;
  --accent: #2563eb;
  --border: #e4e4e7;
  --hover-bg: #f4f4f5;
  --shadow-sm: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  --font-stack: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;

  /* Mapping Old Variables to New Theme */
  --bg-primary: var(--bg-color);
  --bg-secondary: var(--card-bg);
  --bg-tertiary: var(--hover-bg);
  --text-primary: var(--text-main);
  --text-secondary: var(--text-muted);
  --text-conformist: #124076; /* Keep original or map if needed */
  /* --text-muted is already defined above, but old one might be used differently. Let's rely on new one */
  --border-color: var(--border);
  --shadow: var(--shadow-sm);
  --shadow-hover: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  
  /* Brand colors - Mapped to Accent */
  --primary: var(--accent);
  --primary-hover: #1d4ed8; /* Darker blue */
  --success: #10b981;
  --success-hover: #059669;
  --danger: #ef4444;
  --danger-hover: #dc2626;
  --warning: #f59e0b;
  --warning-hover: #d97706;
  
  /* Button colors - Simplified */
  --button-1: var(--accent);
  --button-1-hover: #1d4ed8;
  --button-2: #f59e0b;
  --button-2-hover: #d97706;
  --button-3: #10b981;
  --button-3-hover: #059669;
  --button-4: #f59e0b;
  --button-4-hover: #d97706;
  
  /* Spacing */
  --spacing-xs: 0.25rem;
  --spacing-sm: 0.5rem;
  --spacing-md: 1rem;
  --spacing-lg: 1.5rem;
  --spacing-xl: 2rem;
  --spacing-xxl: 3rem;
  
  /* Border radius */
  --border-radius: 0.5rem;
  --border-radius-sm: 0.25rem;
  --border-radius-lg: 0.75rem;
  
  /* Font sizes */
  --font-size-xs: 0.75rem;
  --font-size-sm: 0.875rem;
  --font-size-base: 1rem;
  --font-size-lg: 1.125rem;
  --font-size-xl: 1.25rem;
  --font-size-xxl: 1.5rem;
  --font-size-xxxl: 2rem;
}

/* Dark theme colors */
[data-theme="dark"] {
  /* New Theme Variables (Dark) */
  --bg-color: #09090b;
  --card-bg: #18181b;
  --sidebar-bg: #18181b;
  --text-main: #f4f4f5;
  --text-muted: #a1a1aa;
  --accent: #3b82f6;
  --border: #27272a;
  --hover-bg: #27272a;
  --shadow-sm: none;
  
  /* Mapping Old Variables */
  --bg-primary: var(--bg-color);
  --bg-secondary: var(--card-bg);
  --bg-tertiary: var(--hover-bg);
  --text-primary: var(--text-main);
  --text-secondary: var(--text-muted);
  --border-color: var(--border);
  --shadow: none;
  --shadow-hover: none;
  
  /* Dark theme button colors */
  --button-1: var(--accent);
  --button-1-hover: #2563eb;
  --button-2: #f59e0b;
  --button-2-hover: #d97706;
  --button-3: #10b981;
  --button-3-hover: #059669;
  --button-4: #f59e0b;
  --button-4-hover: #d97706;
}

/* Base styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: var(--font-stack);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  line-height: 1.6;
  transition: background-color 0.3s ease, color 0.3s ease;
}

/* App container */
.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Header */
.header {
  background-color: var(--bg-secondary);
  border-bottom: 1px solid var(--border-color);
  padding: var(--spacing-md) var(--spacing-xl);
  box-shadow: 0 2px 4px var(--shadow);
}

.header-content {
  width: 100%;
  max-width: 98%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  font-size: var(--font-size-xl);
  font-weight: 700;
  color: var(--primary);
  text-decoration: none;
}

.logo-image {
  height: 50px;
  width: auto;
  object-fit: contain;
}

.logo-text {
  font-size: var(--font-size-xl);
  font-weight: 700;
  color: var(--primary);
}

.nav {
  display: flex;
  align-items: center;
  gap: var(--spacing-lg);
}

.nav-link {
  color: var(--text-secondary);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.nav-link:hover {
  color: var(--primary);
}

/* Theme toggle button */
.theme-toggle {
  background: none;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius);
  padding: var(--spacing-sm);
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.2s ease;
}

.theme-toggle:hover {
  background-color: var(--bg-tertiary);
  border-color: var(--primary);
}

/* Main content */
.main {
  min-height: 95vh;
  padding: var(--spacing-xl);
  max-width: 98%;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}

/* Forms */
.form-container {
  max-width: 400px;
  margin: var(--spacing-xxl) auto;
  padding: var(--spacing-xl);
  background-color: var(--bg-secondary);
  border-radius: var(--border-radius-lg);
  box-shadow: 0 4px 6px var(--shadow);
}

.form-title {
  font-size: var(--font-size-xxl);
  font-weight: 600;
  text-align: center;
  margin-bottom: var(--spacing-xl);
  color: var(--text-primary);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg);
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}

.form-label {
  font-weight: 500;
  color: var(--text-primary);
  font-size: var(--font-size-sm);
}

.form-input {
  padding: var(--spacing-md);
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius);
  background-color: var(--bg-primary);
  color: var(--text-primary);
  font-size: var(--font-size-base);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.form-input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
}

.form-input.error {
  border-color: var(--danger);
}

.form-input.error:focus {
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
}

/* Buttons */
.btn {
  padding: var(--spacing-md) var(--spacing-lg);
  border: none;
  border-radius: var(--border-radius);
  font-size: var(--font-size-base);
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm);
  transition: all 0.2s ease;
  min-height: 44px; /* Accessibility: minimum touch target */
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background-color: var(--primary);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background-color: var(--primary-hover);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px var(--shadow-hover);
}

.btn-secondary {
  background-color: var(--button-2);
  color: var(--bg-primary);
  border: 1px solid var(--border-color);
}

.btn-secondary:hover:not(:disabled) {
  background-color: var(--bg-secondary);
  border-color: var(--primary);
}

.btn-danger {
  background-color: var(--danger);
  color: white;
}

.btn-danger:hover:not(:disabled) {
  background-color: var(--danger-hover);
}

.btn-link {
  background: none;
  color: var(--primary);
  border: none;
  padding: 0;
  font-size: var(--font-size-sm);
  text-decoration: underline;
}

.btn-link:hover {
  color: var(--primary-hover);
}

/* Loading spinner */
.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Alert messages */
.alert {
  padding: var(--spacing-md) var(--spacing-lg);
  border-radius: var(--border-radius);
  margin-bottom: var(--spacing-lg);
  border: 1px solid transparent;
}

.alert-error {
  background-color: rgba(220, 53, 69, 0.1);
  color: var(--danger);
  border-color: rgba(220, 53, 69, 0.2);
}

.alert-success {
  background-color: rgba(25, 135, 84, 0.1);
  color: var(--success);
  border-color: rgba(25, 135, 84, 0.2);
}

.alert-warning {
  background-color: rgba(255, 193, 7, 0.1);
  color: var(--warning);
  border-color: rgba(255, 193, 7, 0.2);
}

/* Card component */
.card {
  background-color: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-xl);
  box-shadow: 0 2px 4px var(--shadow);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.card:hover {
  box-shadow: 0 4px 8px var(--shadow-hover);
  transform: translateY(-2px);
}

.card-header {
  margin-bottom: var(--spacing-lg);
  padding-bottom: var(--spacing-md);
  border-bottom: 1px solid var(--border-color);
}

.card-title {
  font-size: var(--font-size-lg);
  font-weight: 600;
  color: var(--text-primary);
}

.card-content {
  color: var(--text-secondary);
}

/* Dashboard layout */
.dashboard {
  padding: 0;
}

/* Tab Navigation */
.tab-navigation {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 2rem;
  border-bottom: 2px solid var(--border-color);
  background: var(--bg-secondary);
  border-radius: 12px 12px 0 0;
  padding: 1rem 1rem 0 1rem;
}

.tab-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 1.5rem;
  border: none;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  border-radius: 8px 8px 0 0;
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.3s ease;
  border-bottom: 3px solid transparent;
}

.tab-button:hover {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.tab-button.active {
  background: var(--bg-primary);
  color: var(--primary);
  border-bottom: 3px solid var(--primary);
}

.tab-icon {
  font-size: 1.2rem;
}

.tab-label {
  font-weight: 600;
}

.tab-content {
  background: var(--bg-secondary);
  border-radius: 0 0 12px 12px;
  padding: 2rem;
  border: 1px solid var(--border-color);
  border-top: none;
  width: 100%;
  box-sizing: border-box;
}

/* Welcome message */
.welcome-message {
  text-align: center;
  padding: var(--spacing-xxl);
}

.welcome-title {
  font-size: var(--font-size-xxxl);
  font-weight: 700;
  margin-bottom: var(--spacing-md);
  color: var(--text-primary);
}

.welcome-subtitle {
  font-size: var(--font-size-lg);
  color: var(--text-secondary);
  margin-bottom: var(--spacing-xl);
}

/* Form links */
.form-links {
  text-align: center;
  margin-top: var(--spacing-lg);
  padding-top: var(--spacing-lg);
  border-top: 1px solid var(--border-color);
}

.form-links p {
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
}

/* Mobile-First Responsive Design */

/* Mobile Table Styles */
@media (max-width: 768px) {
  /* Header responsive */
  .header {
    padding: var(--spacing-md);
  }
  
  .header-content {
    flex-direction: column;
    gap: var(--spacing-md);
    align-items: stretch;
  }
  
  .nav {
    flex-direction: column;
    gap: var(--spacing-sm);
    align-items: stretch;
  }
  
  .nav .btn {
    width: 100%;
    justify-content: center;
  }
  
  /* Main content */
  .main {
    padding: var(--spacing-md);
  }
  
  /* Welcome message */
  .welcome-message {
    padding: var(--spacing-lg);
  }
  
  .welcome-title {
    font-size: var(--font-size-xxl);
  }
  
  .welcome-subtitle {
    font-size: var(--font-size-base);
  }
  
  /* Tab Navigation Mobile */
  .tab-navigation {
    flex-direction: column;
    gap: 0;
    padding: 0;
    border-radius: var(--border-radius);
    overflow: hidden;
  }
  
  .tab-button {
    border-radius: 0;
    border-bottom: 1px solid var(--border-color);
    padding: var(--spacing-lg);
    justify-content: flex-start;
  }
  
  .tab-button:last-child {
    border-bottom: none;
  }
  
  .tab-button.active {
    border-bottom: 1px solid var(--border-color);
    border-left: 4px solid var(--primary);
  }
  
  .tab-content {
    border-radius: var(--border-radius);
    padding: var(--spacing-lg);
  }
  
  /* Table Mobile Optimization */
  .table-container {
    overflow-x: auto;
  }
  
  .table-filters {
    flex-direction: column;
    gap: var(--spacing-md);
  }
  
  .filter-group {
    min-width: auto;
    width: 100%;
  }
  
  .filter-clear {
    width: 100%;
    margin-top: var(--spacing-sm);
  }
  
  /* Mobile Table - Card Layout */
  .table-wrapper {
    border: none;
    border-radius: 0;
  }
  
  .data-table {
    display: none; /* Hide table on mobile */
  }
  
  /* Mobile Card Layout */
  .mobile-cards {
    display: block;
  }
  
  .mobile-card {
    background: var(--bg-secondary);
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius);
    padding: var(--spacing-lg);
    margin-bottom: var(--spacing-md);
    box-shadow: 0 2px 4px var(--shadow);
  }
  
  .mobile-card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: var(--spacing-md);
    padding-bottom: var(--spacing-sm);
    border-bottom: 1px solid var(--border-color);
  }
  
  .mobile-card-title {
    font-weight: 600;
    color: var(--text-primary);
    font-size: var(--font-size-lg);
    margin: 0;
    flex: 1 1;
    margin-right: var(--spacing-md);
  }
  
  .mobile-card-badges {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xs);
    align-items: flex-end;
  }
  
  .mobile-card-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--spacing-md);
  }
  
  .mobile-card-field {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xs);
  }
  
  .mobile-card-field.full-width {
    grid-column: 1 / -1;
  }
  
  .mobile-card-label {
    font-size: var(--font-size-xs);
    font-weight: 600;
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  
  .mobile-card-value {
    font-size: var(--font-size-sm);
    color: var(--text-primary);
    word-break: break-word;
  }
  
  .mobile-card-value.price {
    font-weight: 600;
    color: var(--primary);
    font-size: var(--font-size-base);
  }
  
  .mobile-card-actions {
    margin-top: var(--spacing-md);
    padding-top: var(--spacing-md);
    border-top: 1px solid var(--border-color);
    display: flex;
    justify-content: flex-end;
  }
  
  /* Pagination Mobile */
  .pagination {
    flex-direction: column;
    gap: var(--spacing-md);
    text-align: center;
  }
  
  .pagination-controls {
    justify-content: center;
    flex-wrap: wrap;
  }
  
  .pagination-controls button {
    padding: 0.5rem 0.75rem;
    font-size: 0.8rem;
    min-width: 44px; /* Accessibility: minimum touch target */
  }
  
  .page-info {
    font-size: 0.8rem;
    padding: 0 0.5rem;
  }
  
  /* Form responsive */
  .form-container {
    margin: var(--spacing-lg) auto;
    padding: var(--spacing-lg);
    max-width: none;
  }
  
  .dashboard {
    grid-template-columns: 1fr;
    gap: var(--spacing-lg);
  }
  
  /* Request Form Mobile */
  .request-form-container {
    padding: var(--spacing-md);
  }
  
  .request-form-container .form-header h2 {
    font-size: var(--font-size-xxl);
  }
  
  .request-form-container .form-subtitle {
    font-size: var(--font-size-base);
  }
  
  .request-form-grid {
    grid-template-columns: 1fr;
    gap: var(--spacing-lg);
  }
  
  .form-card {
    padding: var(--spacing-lg);
  }
  
  .form-card .card-title {
    font-size: var(--font-size-lg);
  }
  
  .providers-card {
    grid-row: span 1; /* Reset row span on mobile */
    grid-column: auto; /* Reset column positioning on mobile */
  }
  
  .search-term-card {
    grid-column: auto; /* Reset column positioning on mobile */
    grid-row: auto; /* Reset row positioning on mobile */
  }
  
  .additional-info-card {
    grid-column: auto; /* Reset column positioning on mobile */
    grid-row: auto; /* Reset row positioning on mobile */
  }
  
  .providers-controls {
    flex-direction: column;
    gap: var(--spacing-md);
  }
  
  .provider-search {
    min-width: auto;
    width: 100%;
  }
  
  .select-all-btn {
    width: 100%;
  }
  
  .providers-grid {
    grid-template-columns: 1fr;
    gap: var(--spacing-md);
    max-height: 300px;
  }
  
  .provider-card {
    padding: var(--spacing-md);
  }
  
  .submit-btn {
    width: 100%;
    padding: var(--spacing-lg);
    font-size: var(--font-size-lg);
  }
  
  .requests-list {
    grid-template-columns: 1fr;
  }
  
  .request-item {
    padding: var(--spacing-md);
  }
  
  .request-content {
    flex-direction: column;
    align-items: stretch;
    gap: var(--spacing-md);
  }
  
  .request-actions {
    justify-content: center;
    margin-left: 0;
    margin-top: var(--spacing-sm);
  }
  
  .request-actions .btn {
    width: 100%;
    justify-content: center;
    min-height: 44px;
  }
  
  /* Legacy Request Form Mobile */
  .request-form {
    padding: var(--spacing-lg);
  }
  
  .providers-header {
    gap: var(--spacing-md);
  }
  
  .form-actions {
    margin-top: var(--spacing-lg);
  }
  
  .previous-requests {
    padding: var(--spacing-md);
  }
}

/* Tablet Responsive Design */
@media (min-width: 769px) and (max-width: 1024px) {
  .request-form-container {
    padding: var(--spacing-lg);
  }
  
  .request-form-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: var(--spacing-lg);
  }
  
  .providers-card {
    grid-column: 1 / -1; /* Full width on tablet */
    grid-row: span 1;
  }
  
  .form-card .card-title {
    font-size: var(--font-size-lg);
  }
  
  .providers-grid {
    max-height: 350px;
  }
}

/* Desktop Table Display */
@media (min-width: 769px) {
  .mobile-cards {
    display: none;
  }
  
  .data-table {
    display: table;
  }
}

@media (max-width: 480px) {
  .header {
    padding: var(--spacing-sm);
  }
  
  .main {
    padding: var(--spacing-sm);
  }
  
  .form-container {
    margin: var(--spacing-md) auto;
    padding: var(--spacing-md);
  }
  
  .welcome-message {
    padding: var(--spacing-md);
  }
  
  .welcome-title {
    font-size: var(--font-size-xl);
  }
  
  .tab-content {
    padding: var(--spacing-md);
  }
  
  .mobile-card {
    padding: var(--spacing-md);
  }
  
  .mobile-card-content {
    grid-template-columns: 1fr;
  }
  
  .mobile-card-field {
    grid-column: 1;
  }
}

/* Landing Page Styles */
.landing-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.landing-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-xl);
  width: 100%;
}

/* Hero Section */
.landing-hero {
  background: linear-gradient(180deg, var(--bg-secondary) 20%, var(--bg-tertiary) 100%);
  padding: var(--spacing-xxl) 0;
  text-align: center;
  border-bottom: 1px solid var(--border-color);
}

.landing-hero-content {
  max-width: 800px;
  margin: 0 auto;
}

.landing-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-md);
  margin-bottom: var(--spacing-xl);
}

.landing-logo-image {
  height: 80px;
  width: auto;
  object-fit: contain;
}

.landing-title {
  font-size: var(--font-size-xxxl);
  font-weight: 700;
  color: var(--primary);
  margin: 0;
}

.landing-subtitle {
  font-size: var(--font-size-xxl);
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 var(--spacing-lg) 0;
}

.landing-description {
  font-size: var(--font-size-lg);
  color: var(--text-secondary);
  margin: 0 0 var(--spacing-xxl) 0;
  line-height: 1.6;
}

.landing-actions {
  display: flex;
  gap: var(--spacing-lg);
  justify-content: center;
  flex-wrap: wrap;
}

.btn-large {
  padding: var(--spacing-lg) var(--spacing-xxl);
  font-size: var(--font-size-lg);
  min-height: 56px;
}

/* Features Section */
.landing-features {
  padding: var(--spacing-xxl) 0;
  background: var(--bg-primary);
}

.section-title {
  font-size: var(--font-size-xxl);
  font-weight: 600;
  color: var(--text-primary);
  text-align: center;
  margin: 0 0 var(--spacing-xxl) 0;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--spacing-xl);
}

.feature-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-xl);
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px var(--shadow);
}

.feature-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px var(--shadow-hover);
}

.feature-icon {
  font-size: 3rem;
  margin-bottom: var(--spacing-md);
}

.feature-title {
  font-size: var(--font-size-lg);
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 var(--spacing-md) 0;
}

.feature-description {
  color: var(--text-secondary);
  margin: 0;
  line-height: 1.6;
}

/* Call-to-Action Section */
.landing-cta {
  padding: var(--spacing-xxl) 0;
  background: linear-gradient(0deg, var(--bg-tertiary) 0%, var(--bg-secondary) 100%);
  text-align: center;
  border-top: 1px solid var(--border-color);
}

.cta-title {
  font-size: var(--font-size-xxl);
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 var(--spacing-lg) 0;
}

.cta-description {
  font-size: var(--font-size-lg);
  color: var(--text-secondary);
  margin: 0 0 var(--spacing-xxl) 0;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.cta-actions {
  display: flex;
  gap: var(--spacing-lg);
  justify-content: center;
  flex-wrap: wrap;
}

/* Footer Section */
.landing-footer {
  background: var(--bg-secondary);
  border-top: 1px solid var(--border-color);
  padding: var(--spacing-xxl) 0 var(--spacing-lg) 0;
  margin-top: auto;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--spacing-xl);
  margin-bottom: var(--spacing-xl);
}

.footer-section {
  text-align: left;
}

.footer-title {
  font-size: var(--font-size-lg);
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 var(--spacing-md) 0;
}

.footer-description {
  color: var(--text-secondary);
  margin: 0;
  line-height: 1.6;
}

.footer-contact {
  color: var(--text-secondary);
  margin: 0;
  line-height: 1.8;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}

.footer-link {
  color: var(--text-secondary);
  text-decoration: none;
  transition: color 0.2s ease;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  text-align: left;
}

.footer-link:hover {
  color: var(--primary);
}

.footer-link:focus {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

.footer-bottom {
  text-align: center;
  padding-top: var(--spacing-lg);
  border-top: 1px solid var(--border-color);
  color: var(--text-muted);
  margin: 0;
}

/* Mobile Responsive Styles for Landing Page */
@media (max-width: 768px) {
  .landing-container {
    padding: 0 var(--spacing-md);
  }
  
  .landing-hero {
    padding: var(--spacing-xl) 0;
  }
  
  .landing-logo {
    flex-direction: column;
    gap: var(--spacing-sm);
  }
  
  .landing-logo-image {
    height: 60px;
  }
  
  .landing-title {
    font-size: var(--font-size-xxl);
  }
  
  .landing-subtitle {
    font-size: var(--font-size-xl);
  }
  
  .landing-description {
    font-size: var(--font-size-base);
  }
  
  .landing-actions {
    flex-direction: column;
    align-items: center;
  }
  
  .btn-large {
    width: 100%;
    max-width: 300px;
  }
  
  .landing-features,
  .landing-cta {
    padding: var(--spacing-xl) 0;
  }
  
  .section-title,
  .cta-title {
    font-size: var(--font-size-xl);
  }
  
  .cta-description {
    font-size: var(--font-size-base);
  }
  
  .features-grid {
    grid-template-columns: 1fr;
    gap: var(--spacing-lg);
  }
  
  .feature-card {
    padding: var(--spacing-lg);
  }
  
  .footer-content {
    grid-template-columns: 1fr;
    gap: var(--spacing-lg);
  }
  
  .footer-section {
    text-align: center;
  }
  
  .footer-links {
    align-items: center;
  }
}

@media (max-width: 480px) {
  .landing-container {
    padding: 0 var(--spacing-sm);
  }
  
  .landing-hero {
    padding: var(--spacing-lg) 0;
  }
  
  .landing-logo-image {
    height: 50px;
  }
  
  .landing-title {
    font-size: var(--font-size-xl);
  }
  
  .landing-subtitle {
    font-size: var(--font-size-lg);
  }
  
  .feature-icon {
    font-size: 2.5rem;
  }
  
  .feature-card {
    padding: var(--spacing-md);
  }
}

/* Utility classes */
.text-center {
  text-align: center;
}

.text-left {
  text-align: left;
}

.text-right {
  text-align: right;
}

.mt-0 { margin-top: 0; }
.mt-1 { margin-top: var(--spacing-sm); }
.mt-2 { margin-top: var(--spacing-md); }
.mt-3 { margin-top: var(--spacing-lg); }
.mt-4 { margin-top: var(--spacing-xl); }

.mb-0 { margin-bottom: 0; }
.mb-1 { margin-bottom: var(--spacing-sm); }
.mb-2 { margin-bottom: var(--spacing-md); }
.mb-3 { margin-bottom: var(--spacing-lg); }
.mb-4 { margin-bottom: var(--spacing-xl); }

.d-flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.align-center {
  align-items: center;
}

.gap-1 { gap: var(--spacing-sm); }
.gap-2 { gap: var(--spacing-md); }
.gap-3 { gap: var(--spacing-lg); }

/* Focus styles for accessibility */
.form-input:focus,
.btn:focus,
.theme-toggle:focus {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

/* Smooth transitions */
* {
  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
}

/* Table Container - styled as a card */
.table-container {
  width: 100%;
  max-width: none;
  background-color: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: var(--shadow);
}

.table-header {
  margin-bottom: 1.5rem;
}

.table-header h2 {
  margin: 0 0 0.5rem 0;
  color: var(--text-primary);
  font-size: 1.5rem;
}

.table-subtitle {
  color: var(--text-secondary);
  margin: 0;
  font-size: 0.9rem;
}

/* Table Filters */
.table-filters {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  align-items: end;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 200px;
}

.filter-group label {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-primary);
}

.filter-group input {
  padding: 0.75rem;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 0.9rem;
  transition: border-color 0.3s ease;
}

.filter-group input:focus {
  outline: none;
  border-color: var(--primary);
}

.filter-clear {
  padding: 0.75rem 1rem;
  background: var(--text-secondary);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: opacity 0.3s ease;
}

.filter-clear:hover {
  opacity: 0.9;
}

/* Items per page select */
.items-per-page-select {
  padding: 0.75rem;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 0.9rem;
  transition: border-color 0.3s ease;
  cursor: pointer;
  min-width: 80px;
}

.items-per-page-select:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
}

.items-per-page-select:hover {
  border-color: var(--primary);
}

/* Data Table */
.table-wrapper {
  overflow-x: auto;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  margin-bottom: 1rem;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.data-table th {
  background: var(--bg-tertiary);
  padding: 1rem 0.75rem;
  text-align: left;
  font-weight: 600;
  color: var(--text-primary);
  border-bottom: 2px solid var(--border-color);
  white-space: nowrap;
}

.data-table th.sortable {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.3s ease;
}

.data-table th.sortable:hover {
  background: var(--bg-secondary);
}

.data-table td {
  padding: 0.75rem;
  border-bottom: 1px solid var(--border-color);
  color: var(--text-primary);
  vertical-align: top;
}

.data-table tbody tr:hover {
  background: var(--bg-tertiary);
}

/* Table Cell Styles */
.title-cell {
  max-width: 250px;
  word-wrap: break-word;
}

.type-badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 500;
  text-transform: capitalize;
  background: var(--text-secondary);
  color: white;
}


.keyword-badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 500;
  text-transform: capitalize;
  background: var(--text-conformist);
  color: white;
}

.provider-tag {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  background: var(--bg-tertiary);
  color: var(--text-primary);
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 500;
}

.price-cell {
  font-weight: 600;
  color: var(--primary);
  white-space: nowrap;
}

.description-cell {
  max-width: 200px;
  word-wrap: break-word;
  line-height: 1.4;
}

.url-link {
  color: var(--primary);
  text-decoration: none;
  font-weight: 500;
  font-size: 0.9rem;
}

.url-link:hover {
  text-decoration: underline;
}

/* PDF Table Specific */
.file-name-cell {
  max-width: 250px;
  min-width: 180px;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.file-icon {
  font-size: 1.5rem;
}

.file-details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.file-ext {
  color: var(--text-secondary);
  font-weight: 600;
}

.page-count {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.9rem;
}

.download-link {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  color: var(--primary);
  text-decoration: none;
  font-weight: 500;
  font-size: 0.9rem;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: inherit;
}

.download-link:hover {
  text-decoration: underline;
}

.download-link:focus {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
  border-radius: 2px;
}

.no-download {
  color: var(--text-secondary);
}

/* File name link styles for diavgeia provider */
.file-name-link {
  color: var(--primary);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease, text-decoration 0.2s ease;
}

.file-name-link:hover {
  color: var(--primary-hover);
  text-decoration: underline;
}

.file-name-link:focus {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
  border-radius: 2px;
}

/* Improved table column widths to prevent overlapping */
.data-table th:nth-child(1) { /* Date column */
  min-width: 100px;
  max-width: 120px;
}

.data-table th:nth-child(2) { /* Query column */
  min-width: 150px;
  max-width: 200px;
}

.data-table th:nth-child(3) { /* File Name column */
  min-width: 250px;
  max-width: 300px;
}

.data-table th:nth-child(4) { /* Provider column */
  min-width: 120px;
  max-width: 150px;
}

.data-table th:nth-child(5) { /* Pages column */
  min-width: 80px;
  max-width: 100px;
}

.data-table th:nth-child(6) { /* Information column */
  min-width: 200px;
  max-width: 250px;
}

.data-table th:nth-child(7) { /* Download column */
  min-width: 100px;
  max-width: 120px;
}

/* Ensure proper word wrapping and overflow handling */
.data-table td {
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
}

.data-table .file-name-cell {
  word-break: break-all;
  overflow-wrap: anywhere;
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  padding: 1rem;
  background: var(--bg-secondary);
  border-radius: 8px;
  border: 1px solid var(--border-color);
}

.pagination-info {
  font-size: 0.9rem;
  color: var(--text-secondary);
}

.pagination-controls {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.pagination-controls button {
  padding: 0.5rem 1rem;
  border: 1px solid var(--border-color);
  background: var(--bg-secondary);
  color: var(--text-primary);
  cursor: pointer;
  border-radius: 4px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.pagination-controls button:hover:not(:disabled) {
  background: var(--primary);
  color: white;
}

.pagination-controls button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  font-size: 0.9rem;
  color: var(--text-primary);
  padding: 0 1rem;
}

/* Request Form Container */
.request-form-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0; /* Remove padding to align with dashboard */
}

/* When RequestForm is inside tab-content, adjust spacing */
.tab-content .request-form-container {
  padding: 0;
  max-width: none; /* Use full width of tab-content */
}

.request-form-container .form-header {
  text-align: center;
  margin-bottom: var(--spacing-xxl);
}

.request-form-container .form-header h2 {
  font-size: var(--font-size-xxxl);
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: var(--spacing-md);
}

.request-form-container .form-subtitle {
  font-size: var(--font-size-lg);
  color: var(--text-secondary);
  max-width: 600px;
  margin: 0 auto;
}

/* Request Form Grid Layout */
.request-form-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--spacing-lg);
  margin-bottom: var(--spacing-xl);
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

/* Form Cards */
.form-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-lg);
  box-shadow: 0 4px 6px var(--shadow);
  transition: all 0.3s ease;
  height: fit-content;
  min-width: 0; /* Allow cards to shrink */
}

.form-card:hover {
  box-shadow: 0 8px 25px var(--shadow-hover);
  transform: translateY(-2px);
}

.form-card .card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--spacing-lg);
  padding-bottom: var(--spacing-md);
  border-bottom: 2px solid var(--border-color);
}

.form-card .card-title {
  font-size: var(--font-size-xl);
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.form-card .card-content {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
}

/* Items per page container in card header */
.items-per-page-container {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  margin-left: auto;
}

.items-per-page-container label {
  font-size: var(--font-size-sm);
  font-weight: 500;
  color: var(--text-secondary);
  white-space: nowrap;
}

.items-per-page-container .items-per-page-select {
  padding: 0.5rem;
  font-size: var(--font-size-sm);
  min-width: 60px;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-sm);
  background: var(--bg-primary);
  color: var(--text-primary);
  transition: all 0.2s ease;
}

.items-per-page-container .items-per-page-select:hover {
  border-color: var(--primary);
}

.items-per-page-container .items-per-page-select:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.1);
}

/* Mobile responsive for items per page container */
@media (max-width: 768px) {
  .items-per-page-container {
    margin-left: 0;
    margin-top: var(--spacing-sm);
    width: 100%;
    justify-content: flex-start;
  }
  
  .items-per-page-container .items-per-page-select {
    flex: 1 1;
  }
}

/* Specific Card Styles */
.search-term-card {
  background: linear-gradient(135deg, var(--bg-secondary) 0%, var(--bg-tertiary) 100%);
  grid-column: 3; /* Position in third column */
  grid-row: 1; /* First row */
}

.providers-card {
  background: linear-gradient(135deg, var(--bg-secondary) 0%, var(--bg-tertiary) 100%);
  grid-column: 1 / 3; /* Span first two columns */
  grid-row: 1 / 3; /* Span two rows */
}

.additional-info-card {
  background: linear-gradient(135deg, var(--bg-secondary) 0%, var(--bg-tertiary) 100%);
  grid-column: 3; /* Position in third column */
  grid-row: 2; /* Second row */
}

.submit-card {
  grid-column: 1 / -1; /* Full width */
  background: var(--primary);
  color: white;
  text-align: center;
  padding: var(--spacing-lg);
}

.submit-card .card-content {
  align-items: center;
}

.previous-requests-card {
  grid-column: 1 / -1; /* Full width */
  background: linear-gradient(135deg, var(--bg-secondary) 0%, var(--bg-tertiary) 100%);
}

/* Enhanced Form Elements */
.form-card .form-input,
.form-card .form-textarea {
  border: 2px solid var(--border-color);
  border-radius: var(--border-radius);
  padding: var(--spacing-md);
  font-size: var(--font-size-base);
  transition: all 0.3s ease;
  background: var(--bg-primary);
  color: var(--text-primary);
}

.form-card .form-input:focus,
.form-card .form-textarea:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
  transform: translateY(-1px);
}

.form-card .form-textarea {
  resize: vertical;
  min-height: 120px;
}

/* Provider Controls Enhancement */
.providers-controls {
  display: flex;
  gap: var(--spacing-md);
  margin-bottom: var(--spacing-lg);
}

.provider-search {
  flex: 1 1;
  border: 2px solid var(--border-color);
  border-radius: var(--border-radius);
  padding: var(--spacing-md);
  background: var(--bg-primary);
  color: var(--text-primary);
  transition: all 0.3s ease;
}

.provider-search:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
}

.select-all-btn {
  padding: var(--spacing-md) var(--spacing-lg);
  background: var(--primary);
  color: white;
  border: none;
  border-radius: var(--border-radius);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.select-all-btn:hover {
  background: var(--primary-hover);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px var(--shadow-hover);
}

/* Enhanced Provider Grid */
.providers-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--spacing-md);
  max-height: 400px;
  overflow-y: auto;
  padding-right: var(--spacing-sm);
}

.providers-grid::-webkit-scrollbar {
  width: 6px;
}

.providers-grid::-webkit-scrollbar-track {
  background: var(--bg-tertiary);
  border-radius: 3px;
}

.providers-grid::-webkit-scrollbar-thumb {
  background: var(--primary);
  border-radius: 3px;
}

.provider-card {
  border: 2px solid var(--border-color);
  border-radius: var(--border-radius);
  padding: var(--spacing-md);
  cursor: pointer;
  transition: all 0.3s ease;
  background: var(--bg-primary);
}

.provider-card:hover {
  border-color: var(--primary);
  box-shadow: 0 4px 8px var(--shadow);
  transform: translateY(-1px);
}

.provider-card.selected {
  border-color: var(--primary);
  background: rgba(13, 110, 253, 0.1);
  box-shadow: 0 0 0 1px var(--primary);
}

/* Enhanced Submit Button */
.submit-btn {
  padding: var(--spacing-lg) var(--spacing-xxl);
  background: white;
  color: var(--primary);
  border: 2px solid white;
  border-radius: var(--border-radius-lg);
  font-size: var(--font-size-lg);
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm);
  min-height: 60px;
}

.submit-btn:hover:not(:disabled) {
  background: var(--bg-primary);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Enhanced Messages */
.error-message,
.success-message {
  padding: var(--spacing-md) var(--spacing-lg);
  border-radius: var(--border-radius);
  margin-bottom: var(--spacing-md);
  font-weight: 500;
  text-align: center;
}

.error-message {
  background: rgba(220, 53, 69, 0.1);
  color: var(--danger);
  border: 2px solid rgba(220, 53, 69, 0.2);
}

.success-message {
  background: var(--bg-primary);
  color: var(--success);
  border: 2px solid rgba(25, 135, 84, 0.2);
}

/* Previous Requests Enhancement */
.requests-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: var(--spacing-md);
}

.request-item {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius);
  padding: var(--spacing-lg);
  transition: all 0.3s ease;
}

.request-item:hover {
  box-shadow: 0 4px 8px var(--shadow);
  transform: translateY(-1px);
}

/* Request Form Styles - Legacy Support */
.request-form {
  background: var(--bg-secondary);
  padding: 2rem;
  border-radius: 12px;
  border: 1px solid var(--border-color);
  margin-bottom: 2rem;
}

.form-textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 1rem;
  font-family: inherit;
  transition: border-color 0.3s ease;
  resize: vertical;
  min-height: 80px;
}

.form-textarea:focus {
  outline: none;
  border-color: var(--primary);
}

.form-hint {
  display: block;
  margin-top: 0.25rem;
  font-size: 0.8rem;
  color: var(--text-secondary);
}

.required {
  color: var(--danger);
}

.optional {
  color: var(--text-secondary);
  font-weight: normal;
}

/* Provider Selection */
.providers-header {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
}

.providers-controls {
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
}

.provider-search {
  flex: 1 1;
  min-width: 200px;
  padding: 0.75rem;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 0.9rem;
  transition: border-color 0.3s ease;
}

.provider-search:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
}

.select-all-btn {
  padding: 0.75rem 1rem;
  background: var(--bg-tertiary);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.select-all-btn:hover {
  background: var(--primary);
  color: white;
  border-color: var(--primary);
}

.providers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-bottom: 1rem;
}

/* Ensure grid works on different screen sizes */
@media (min-width: 1200px) {
  .providers-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 900px) and (max-width: 1199px) {
  .providers-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 769px) and (max-width: 899px) {
  .providers-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.provider-selection-info {
  margin-top: 0.5rem;
}

.provider-card {
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  background: var(--bg-secondary);
}

.provider-card:hover {
  border-color: var(--primary);
  box-shadow: 0 2px 8px var(--shadow);
}

.provider-card.selected {
  border-color: var(--primary);
  background: var(--bg-tertiary);
}

.provider-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.provider-checkbox {
  cursor: pointer;
}

.provider-name {
  margin: 0;
  font-size: 1rem;
  color: var(--text-primary);
}

.provider-link {
  margin-bottom: 0.5rem;
}

.provider-link a {
  color: var(--primary);
  text-decoration: none;
  font-size: 0.9rem;
}

.provider-link a:hover {
  text-decoration: underline;
}

.provider-properties {
  color: var(--text-secondary);
  font-size: 0.8rem;
  line-height: 1.4;
}

/* Form Actions */
.form-actions {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}

.submit-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 2rem;
  background: var(--primary);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  transition: all 0.3s ease;
}

.submit-btn:hover:not(:disabled) {
  opacity: 0.9;
  transform: translateY(-1px);
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.btn-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Previous Requests */
.previous-requests {
  background: var(--bg-secondary);
  padding: 1.5rem;
  border-radius: 12px;
  border: 1px solid var(--border-color);
}

.previous-requests h3 {
  margin: 0 0 1rem 0;
  color: var(--text-primary);
  font-size: 1.2rem;
}

.requests-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.request-item {
  background: var(--bg-tertiary);
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid var(--border-color);
}

.request-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--spacing-md);
}

.request-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.request-term {
  color: var(--text-primary);
  font-size: 1rem;
  font-weight: 600;
}

.request-providers,
.request-status {
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.status-active {
  color: var(--success);
  font-weight: 500;
}

.status-inactive {
  color: var(--danger);
  font-weight: 500;
}

.request-actions {
  flex-shrink: 0;
  margin-left: var(--spacing-md);
}

.request-actions .btn {
  padding: var(--spacing-sm) var(--spacing-md);
  font-size: var(--font-size-sm);
  min-height: 36px;
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
}

.request-actions .btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.request-actions .btn-spinner {
  width: 12px;
  height: 12px;
  border: 1px solid transparent;
  border-top: 1px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Loading and Error States */
.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  gap: 1rem;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255,255,255,0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--border-color);
  border-top: 4px solid var(--primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Error and Success Messages */
.error-message {
  background: rgba(220, 53, 69, 0.1);
  color: var(--danger);
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid rgba(220, 53, 69, 0.2);
  margin: 1rem 0;
}

.error-message button {
  margin-top: 0.5rem;
  padding: 0.5rem 1rem;
  background: var(--danger);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

/* .success-message {
  background: rgba(25, 135, 84, 0.1);
  color: var(--success);
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid rgba(25, 135, 84, 0.2);
  margin: 1rem 0;
} */

/* No Data States */
.no-data,
.no-providers {
  text-align: center;
  padding: 3rem 1rem;
  color: var(--text-secondary);
}

.no-data p,
.no-providers p {
  margin: 0.5rem 0;
  font-size: 1.1rem;
}

.no-providers button {
  margin-top: 1rem;
  padding: 0.75rem 1.5rem;
  background: var(--primary);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

/* Modal Dialog */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.modal-content {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-xl);
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-content h3 {
  margin: 0 0 var(--spacing-lg) 0;
  font-size: var(--font-size-xl);
  font-weight: 600;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.modal-content p {
  margin: 0 0 var(--spacing-md) 0;
  color: var(--text-secondary);
  font-size: var(--font-size-base);
  line-height: 1.5;
}

.modal-content p:last-of-type {
  margin-bottom: var(--spacing-lg);
}

.warning-text {
  color: var(--danger);
  font-weight: 500;
  font-size: var(--font-size-sm);
}

.modal-actions {
  display: flex;
  gap: var(--spacing-md);
  justify-content: flex-end;
  margin-top: var(--spacing-xl);
  padding-top: var(--spacing-lg);
  border-top: 1px solid var(--border-color);
}

.modal-actions .btn {
  min-width: 100px;
}

/* Enhanced Request Actions */
.request-actions {
  display: flex;
  gap: var(--spacing-sm);
  flex-wrap: wrap;
  justify-content: flex-end;
}

.request-actions .btn {
  margin: 0;
  font-size: var(--font-size-sm);
  padding: var(--spacing-sm) var(--spacing-md);
  min-height: 36px;
}

/* Delete Button Styling */
.delete-btn {
  background: var(--danger);
  color: white;
  border: none;
  border-radius: var(--border-radius);
  padding: var(--spacing-sm) var(--spacing-md);
  cursor: pointer;
  font-size: var(--font-size-base);
  font-weight: 500;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  min-width: 36px;
}

.delete-btn:hover:not(:disabled) {
  background: var(--danger-hover);
  transform: translateY(-1px);
  box-shadow: 0 2px 4px var(--shadow-hover);
}

.delete-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.delete-btn:focus {
  outline: 2px solid var(--danger);
  outline-offset: 2px;
}

/* Mobile Delete Button Styling */
.mobile-delete-btn {
  background: var(--danger);
  color: white;
  border: none;
  border-radius: var(--border-radius);
  padding: var(--spacing-sm) var(--spacing-md);
  cursor: pointer;
  font-size: var(--font-size-base);
  font-weight: 500;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px; /* Accessibility: minimum touch target */
  min-width: 44px;
}

.mobile-delete-btn:hover:not(:disabled) {
  background: var(--danger-hover);
  transform: translateY(-1px);
  box-shadow: 0 2px 4px var(--shadow-hover);
}

.mobile-delete-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.mobile-delete-btn:focus {
  outline: 2px solid var(--danger);
  outline-offset: 2px;
}

/* Success Message Styling */
.success-message {
  background: rgba(25, 135, 84, 0.1);
  color: var(--success);
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid rgba(25, 135, 84, 0.2);
  margin: 1rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.success-message button {
  background: var(--success);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-size: var(--font-size-sm);
  transition: all 0.2s ease;
}

.success-message button:hover {
  background: var(--success-hover);
}

/* Bot Detail Card Styles */
.bot-detail-card {
  background: linear-gradient(135deg, var(--bg-secondary) 0%, var(--bg-tertiary) 100%);
  border: 2px solid var(--border-color);
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-xl);
  margin-bottom: var(--spacing-xl);
  box-shadow: 0 4px 6px var(--shadow);
  transition: all 0.3s ease;
}

.bot-detail-card:hover {
  box-shadow: 0 8px 25px var(--shadow-hover);
  transform: translateY(-2px);
  border-color: var(--primary);
}

.bot-detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--spacing-lg);
  padding-bottom: var(--spacing-md);
  border-bottom: 2px solid var(--border-color);
  flex-wrap: wrap;
  gap: var(--spacing-md);
}

.bot-detail-title {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  flex: 1 1;
  min-width: 0;
}

.bot-detail-title h3 {
  margin: 0;
  font-size: var(--font-size-xxl);
  font-weight: 700;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bot-detail-icon {
  font-size: 2rem;
  color: var(--primary);
  flex-shrink: 0;
}

.bot-status-badge {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-xs);
  padding: var(--spacing-sm) var(--spacing-md);
  background: var(--success);
  color: white;
  border-radius: var(--border-radius);
  font-size: var(--font-size-sm);
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
}

.bot-status-badge.active {
  background: var(--success);
}

.bot-status-badge i {
  font-size: 0.6rem;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.bot-detail-stats {
  display: flex;
  gap: var(--spacing-lg);
  flex-wrap: wrap;
}

.bot-stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-xs);
  padding: var(--spacing-md);
  background: var(--bg-primary);
  border-radius: var(--border-radius);
  border: 1px solid var(--border-color);
  min-width: 120px;
  transition: all 0.3s ease;
}

.bot-stat-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px var(--shadow-hover);
  border-color: var(--primary);
}

.bot-stat-item i {
  font-size: var(--font-size-xl);
  color: var(--primary);
}

.bot-stat-label {
  font-size: var(--font-size-xs);
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-align: center;
}

.bot-stat-value {
  font-size: var(--font-size-lg);
  font-weight: 700;
  color: var(--text-primary);
  text-align: center;
}

.bot-detail-content {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg);
}

.bot-detail-section {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}

.bot-detail-label {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-sm);
  font-size: var(--font-size-sm);
  font-weight: 700;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.bot-detail-label i {
  color: var(--primary);
  font-size: var(--font-size-base);
}

.bot-tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-sm);
}

.bot-property-tag {
  display: inline-block;
  padding: var(--spacing-sm) var(--spacing-md);
  background: var(--primary);
  color: white;
  border-radius: var(--border-radius);
  font-size: var(--font-size-sm);
  font-weight: 500;
  transition: all 0.2s ease;
}

.bot-property-tag:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px var(--shadow-hover);
}

.bot-search-tag {
  display: inline-block;
  padding: var(--spacing-sm) var(--spacing-md);
  background: var(--success);
  color: white;
  border-radius: var(--border-radius);
  font-size: var(--font-size-sm);
  font-weight: 500;
  transition: all 0.2s ease;
}

.bot-search-tag:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px var(--shadow-hover);
}

/* Bot Detail Card Mobile Responsiveness */
@media (max-width: 768px) {
  .bot-detail-card {
    padding: var(--spacing-lg);
    margin-bottom: var(--spacing-lg);
  }

  .bot-detail-header {
    flex-direction: column;
    align-items: stretch;
    gap: var(--spacing-md);
  }

  .bot-detail-title {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-sm);
  }

  .bot-detail-title h3 {
    font-size: var(--font-size-xl);
    white-space: normal;
    word-break: break-word;
  }

  .bot-visit-link {
    width: 100%;
    justify-content: center;
  }

  .bot-tags-container {
    gap: var(--spacing-xs);
  }

  .bot-property-tag,
  .bot-search-tag {
    font-size: var(--font-size-xs);
    padding: var(--spacing-xs) var(--spacing-sm);
  }
}

@media (max-width: 480px) {
  .bot-detail-card {
    padding: var(--spacing-md);
  }

  .bot-detail-icon {
    font-size: 1.5rem;
  }

  .bot-detail-title h3 {
    font-size: var(--font-size-lg);
  }

  .bot-status-badge {
    font-size: var(--font-size-xs);
    padding: var(--spacing-xs) var(--spacing-sm);
  }
}

@media (max-width: 768px) {
  .modal-content {
    margin: var(--spacing-md);
    padding: var(--spacing-lg);
    width: calc(100% - 2rem);
  }
  
  .modal-actions {
    flex-direction: column;
    gap: var(--spacing-sm);
  }
  
  .modal-actions .btn {
    width: 100%;
  }
  
  .request-actions {
    flex-direction: column;
    gap: var(--spacing-xs);
  }
  
  .request-actions .btn {
    width: 100%;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,4EAA4E;EAC5E,wFAAwF;;EAExF,uCAAuC;EACvC,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;EAC9B,gCAAgC;EAChC,mCAAmC;EACnC,0BAA0B,EAAE,mCAAmC;EAC/D,wGAAwG;EACxG,6BAA6B;EAC7B,0BAA0B;EAC1B,qFAAqF;;EAErF,oCAAoC;EACpC,wBAAwB;EACxB,wBAAwB,EAAE,gBAAgB;EAC1C,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;;EAExB,+BAA+B;EAC/B,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;;EAEzB,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;;EAEnB,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;;EAE3B,eAAe;EACf,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;;EAEjB,0BAA0B;EAC1B,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;EAC9B,gCAAgC;EAChC,mCAAmC;EACnC,6BAA6B;EAC7B,cAAc;EACd,oBAAoB;;EAEpB,6BAA6B;EAC7B,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,kCAAkC;EAClC,mCAAmC;EACnC,0BAA0B;EAC1B,gBAAgB;EAChB,uDAAuD;AACzD;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,qCAAqC;EACrC,4CAA4C;EAC5C,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mCAAmC;EACnC,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,0BAA0B;EAC1B,qCAAqC;EACrC,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,mCAAmC;EACnC,mCAAmC;EACnC,0BAA0B;EAC1B,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,YAAY;AACZ;EACE,4CAA4C;EAC5C,YAAY;EACZ,mCAAmC;EACnC,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB,EAAE,wCAAwC;AAC5D;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,UAAU;EACV,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,mBAAmB;AACnB;EACE,4CAA4C;EAC5C,mCAAmC;EACnC,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;EACxC,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,mBAAmB;AACnB;EACE,qCAAqC;EACrC,qCAAqC;EACrC,sCAAsC;EACtC,0BAA0B;EAC1B,mCAAmC;EACnC,qDAAqD;AACvD;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,4CAA4C;EAC5C,+BAA+B;EAC/B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA,mCAAmC;;AAEnC,wBAAwB;AACxB;EACE,sBAAsB;EACtB;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA,iBAAiB;EACjB;IACE,0BAA0B;EAC5B;;EAEA,oBAAoB;EACpB;IACE,0BAA0B;EAC5B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,gCAAgC;EAClC;;EAEA,0BAA0B;EAC1B;IACE,sBAAsB;IACtB,MAAM;IACN,UAAU;IACV,mCAAmC;IACnC,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,4CAA4C;IAC5C,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,4CAA4C;IAC5C,qCAAqC;EACvC;;EAEA;IACE,mCAAmC;IACnC,0BAA0B;EAC5B;;EAEA,8BAA8B;EAC9B;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;IACX,6BAA6B;EAC/B;;EAEA,+BAA+B;EAC/B;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa,EAAE,yBAAyB;EAC1C;;EAEA,uBAAuB;EACvB;IACE,cAAc;EAChB;;EAEA;IACE,+BAA+B;IAC/B,qCAAqC;IACrC,mCAAmC;IACnC,0BAA0B;IAC1B,gCAAgC;IAChC,mCAAmC;EACrC;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,gCAAgC;IAChC,iCAAiC;IACjC,4CAA4C;EAC9C;;EAEA;IACE,gBAAgB;IAChB,0BAA0B;IAC1B,8BAA8B;IAC9B,SAAS;IACT,SAAO;IACP,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,gCAAgC;EAClC;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;IAC9B,yCAAyC;IACzC,aAAa;IACb,yBAAyB;EAC3B;;EAEA,sBAAsB;EACtB;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,eAAe,EAAE,wCAAwC;EAC3D;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA,oBAAoB;EACpB;IACE,8BAA8B;IAC9B,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA,wBAAwB;EACxB;IACE,0BAA0B;EAC5B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gBAAgB,EAAE,6BAA6B;IAC/C,iBAAiB,EAAE,uCAAuC;EAC5D;;EAEA;IACE,iBAAiB,EAAE,uCAAuC;IAC1D,cAAc,EAAE,oCAAoC;EACtD;;EAEA;IACE,iBAAiB,EAAE,uCAAuC;IAC1D,cAAc,EAAE,oCAAoC;EACtD;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,cAAc;IACd,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA,+BAA+B;EAC/B;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;IACrC,sBAAsB;EACxB;;EAEA;IACE,mBAAmB,EAAE,yBAAyB;IAC9C,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;IAC9B,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,4BAA4B;EAC5B,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,qFAAqF;EACrF,6BAA6B;EAC7B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,6CAA6C;EAC7C,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,sCAAsC;EACtC,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,6BAA6B;EAC7B,kFAAkF;EAClF,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,+BAA+B;EAC/B,yCAAyC;EACzC,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,yCAAyC;EACzC,wBAAwB;EACxB,SAAS;AACX;;AAEA,8CAA8C;AAC9C;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,QAAQ,aAAa,EAAE;AACvB,QAAQ,6BAA6B,EAAE;AACvC,QAAQ,6BAA6B,EAAE;AACvC,QAAQ,6BAA6B,EAAE;AACvC,QAAQ,6BAA6B,EAAE;;AAEvC,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,gCAAgC,EAAE;AAC1C,QAAQ,gCAAgC,EAAE;AAC1C,QAAQ,gCAAgC,EAAE;AAC1C,QAAQ,gCAAgC,EAAE;;AAE1C;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,SAAS,sBAAsB,EAAE;AACjC,SAAS,sBAAsB,EAAE;AACjC,SAAS,sBAAsB,EAAE;;AAEjC,mCAAmC;AACnC;;;EAGE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,+EAA+E;AACjF;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,eAAe;EACf,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,SAAS;EACT,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,iCAAiC;EACjC,YAAY;AACd;;;AAGA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,gDAAgD;AAChD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,wDAAwD;AACxD,8BAA8B,gBAAgB;EAC5C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,8BAA8B,iBAAiB;EAC7C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,8BAA8B,qBAAqB;EACjD,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,8BAA8B,oBAAoB;EAChD,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,8BAA8B,iBAAiB;EAC7C,eAAe;EACf,gBAAgB;AAClB;;AAEA,8BAA8B,uBAAuB;EACnD,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,8BAA8B,oBAAoB;EAChD,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qCAAqC;EACrC,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,cAAc;EACd,UAAU,EAAE,2CAA2C;AACzD;;AAEA,2DAA2D;AAC3D;EACE,UAAU;EACV,eAAe,EAAE,kCAAkC;AACrD;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,qCAAqC;EACrC,sBAAsB;EACtB,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,sCAAsC;EACtC,0BAA0B;EAC1B,mCAAmC;EACnC,yBAAyB;EACzB,mBAAmB;EACnB,YAAY,EAAE,0BAA0B;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,eAAe;EACf,qCAAqC;EACrC,sCAAsC;EACtC,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA,mDAAmD;AACnD;EACE;IACE,cAAc;IACd,6BAA6B;IAC7B,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,SAAO;EACT;AACF;;AAEA,yBAAyB;AACzB;EACE,oFAAoF;EACpF,cAAc,EAAE,6BAA6B;EAC7C,WAAW,EAAE,cAAc;AAC7B;;AAEA;EACE,oFAAoF;EACpF,kBAAkB,EAAE,2BAA2B;EAC/C,eAAe,EAAE,kBAAkB;AACrC;;AAEA;EACE,oFAAoF;EACpF,cAAc,EAAE,6BAA6B;EAC7C,WAAW,EAAE,eAAe;AAC9B;;AAEA;EACE,mBAAmB,EAAE,eAAe;EACpC,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB,EAAE,eAAe;EACpC,oFAAoF;AACtF;;AAEA,2BAA2B;AAC3B;;EAEE,qCAAqC;EACrC,mCAAmC;EACnC,0BAA0B;EAC1B,gCAAgC;EAChC,yBAAyB;EACzB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;;EAEE,4BAA4B;EAC5B,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,qCAAqC;EACrC,mCAAmC;EACnC,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,4CAA4C;EAC5C,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,0BAA0B;EAC1B,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;EACnC,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA,2BAA2B;AAC3B;EACE,6CAA6C;EAC7C,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;EACvB,sCAAsC;EACtC,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;;EAEE,4CAA4C;EAC5C,mCAAmC;EACnC,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,mCAAmC;EACnC,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA,yCAAyC;AACzC;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,4CAA4C;EAC5C,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,oCAAoC;EACpC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,+BAA+B;AAC/B;EACE,kCAAkC;EAClC,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;;;;;GAOG;;AAEH,mBAAmB;AACnB;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,sCAAsC;EACtC,0BAA0B;EAC1B,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,qFAAqF;EACrF,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mCAAmC;EACnC,4CAA4C;EAC5C,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mCAAmC;EACnC,4CAA4C;EAC5C,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB,EAAE,wCAAwC;EAC1D,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,kCAAkC;EAClC,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B;EACE,oFAAoF;EACpF,qCAAqC;EACrC,sCAAsC;EACtC,0BAA0B;EAC1B,gCAAgC;EAChC,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,iCAAiC;EACjC,4CAA4C;EAC5C,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,0BAA0B;EAC1B,YAAY;EACZ,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,6BAA6B;EAC7B,mCAAmC;EACnC,qCAAqC;EACrC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,0BAA0B;EAC1B,YAAY;EACZ,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,0BAA0B;EAC1B,YAAY;EACZ,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,0CAA0C;AAC1C;EACE;IACE,0BAA0B;IAC1B,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,8BAA8B;IAC9B,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":["/* CSS Custom Properties for theming */\n:root {\n  /* New Theme Variables (from template) */\n  --bg-color: #f4f4f5;\n  --card-bg: #ffffff;\n  --sidebar-bg: #ffffff;\n  --text-main: #18181b;\n  --text-muted: #71717a;\n  --accent: #2563eb;\n  --border: #e4e4e7;\n  --hover-bg: #f4f4f5;\n  --shadow-sm: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  --font-stack: 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n\n  /* Mapping Old Variables to New Theme */\n  --bg-primary: var(--bg-color);\n  --bg-secondary: var(--card-bg);\n  --bg-tertiary: var(--hover-bg);\n  --text-primary: var(--text-main);\n  --text-secondary: var(--text-muted);\n  --text-conformist: #124076; /* Keep original or map if needed */\n  /* --text-muted is already defined above, but old one might be used differently. Let's rely on new one */\n  --border-color: var(--border);\n  --shadow: var(--shadow-sm);\n  --shadow-hover: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  \n  /* Brand colors - Mapped to Accent */\n  --primary: var(--accent);\n  --primary-hover: #1d4ed8; /* Darker blue */\n  --success: #10b981;\n  --success-hover: #059669;\n  --danger: #ef4444;\n  --danger-hover: #dc2626;\n  --warning: #f59e0b;\n  --warning-hover: #d97706;\n  \n  /* Button colors - Simplified */\n  --button-1: var(--accent);\n  --button-1-hover: #1d4ed8;\n  --button-2: #f59e0b;\n  --button-2-hover: #d97706;\n  --button-3: #10b981;\n  --button-3-hover: #059669;\n  --button-4: #f59e0b;\n  --button-4-hover: #d97706;\n  \n  /* Spacing */\n  --spacing-xs: 0.25rem;\n  --spacing-sm: 0.5rem;\n  --spacing-md: 1rem;\n  --spacing-lg: 1.5rem;\n  --spacing-xl: 2rem;\n  --spacing-xxl: 3rem;\n  \n  /* Border radius */\n  --border-radius: 0.5rem;\n  --border-radius-sm: 0.25rem;\n  --border-radius-lg: 0.75rem;\n  \n  /* Font sizes */\n  --font-size-xs: 0.75rem;\n  --font-size-sm: 0.875rem;\n  --font-size-base: 1rem;\n  --font-size-lg: 1.125rem;\n  --font-size-xl: 1.25rem;\n  --font-size-xxl: 1.5rem;\n  --font-size-xxxl: 2rem;\n}\n\n/* Dark theme colors */\n[data-theme=\"dark\"] {\n  /* New Theme Variables (Dark) */\n  --bg-color: #09090b;\n  --card-bg: #18181b;\n  --sidebar-bg: #18181b;\n  --text-main: #f4f4f5;\n  --text-muted: #a1a1aa;\n  --accent: #3b82f6;\n  --border: #27272a;\n  --hover-bg: #27272a;\n  --shadow-sm: none;\n  \n  /* Mapping Old Variables */\n  --bg-primary: var(--bg-color);\n  --bg-secondary: var(--card-bg);\n  --bg-tertiary: var(--hover-bg);\n  --text-primary: var(--text-main);\n  --text-secondary: var(--text-muted);\n  --border-color: var(--border);\n  --shadow: none;\n  --shadow-hover: none;\n  \n  /* Dark theme button colors */\n  --button-1: var(--accent);\n  --button-1-hover: #2563eb;\n  --button-2: #f59e0b;\n  --button-2-hover: #d97706;\n  --button-3: #10b981;\n  --button-3-hover: #059669;\n  --button-4: #f59e0b;\n  --button-4-hover: #d97706;\n}\n\n/* Base styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: var(--font-stack);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n  line-height: 1.6;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n/* App container */\n.app {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Header */\n.header {\n  background-color: var(--bg-secondary);\n  border-bottom: 1px solid var(--border-color);\n  padding: var(--spacing-md) var(--spacing-xl);\n  box-shadow: 0 2px 4px var(--shadow);\n}\n\n.header-content {\n  width: 100%;\n  max-width: 98%;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  font-size: var(--font-size-xl);\n  font-weight: 700;\n  color: var(--primary);\n  text-decoration: none;\n}\n\n.logo-image {\n  height: 50px;\n  width: auto;\n  object-fit: contain;\n}\n\n.logo-text {\n  font-size: var(--font-size-xl);\n  font-weight: 700;\n  color: var(--primary);\n}\n\n.nav {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-lg);\n}\n\n.nav-link {\n  color: var(--text-secondary);\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.2s ease;\n}\n\n.nav-link:hover {\n  color: var(--primary);\n}\n\n/* Theme toggle button */\n.theme-toggle {\n  background: none;\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius);\n  padding: var(--spacing-sm);\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.theme-toggle:hover {\n  background-color: var(--bg-tertiary);\n  border-color: var(--primary);\n}\n\n/* Main content */\n.main {\n  min-height: 95vh;\n  padding: var(--spacing-xl);\n  max-width: 98%;\n  margin: 0 auto;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Forms */\n.form-container {\n  max-width: 400px;\n  margin: var(--spacing-xxl) auto;\n  padding: var(--spacing-xl);\n  background-color: var(--bg-secondary);\n  border-radius: var(--border-radius-lg);\n  box-shadow: 0 4px 6px var(--shadow);\n}\n\n.form-title {\n  font-size: var(--font-size-xxl);\n  font-weight: 600;\n  text-align: center;\n  margin-bottom: var(--spacing-xl);\n  color: var(--text-primary);\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-lg);\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm);\n}\n\n.form-label {\n  font-weight: 500;\n  color: var(--text-primary);\n  font-size: var(--font-size-sm);\n}\n\n.form-input {\n  padding: var(--spacing-md);\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius);\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: var(--font-size-base);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);\n}\n\n.form-input.error {\n  border-color: var(--danger);\n}\n\n.form-input.error:focus {\n  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);\n}\n\n/* Buttons */\n.btn {\n  padding: var(--spacing-md) var(--spacing-lg);\n  border: none;\n  border-radius: var(--border-radius);\n  font-size: var(--font-size-base);\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: none;\n  text-align: center;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-sm);\n  transition: all 0.2s ease;\n  min-height: 44px; /* Accessibility: minimum touch target */\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background-color: var(--primary);\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background-color: var(--primary-hover);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px var(--shadow-hover);\n}\n\n.btn-secondary {\n  background-color: var(--button-2);\n  color: var(--bg-primary);\n  border: 1px solid var(--border-color);\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background-color: var(--bg-secondary);\n  border-color: var(--primary);\n}\n\n.btn-danger {\n  background-color: var(--danger);\n  color: white;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background-color: var(--danger-hover);\n}\n\n.btn-link {\n  background: none;\n  color: var(--primary);\n  border: none;\n  padding: 0;\n  font-size: var(--font-size-sm);\n  text-decoration: underline;\n}\n\n.btn-link:hover {\n  color: var(--primary-hover);\n}\n\n/* Loading spinner */\n.loading-spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid transparent;\n  border-top: 2px solid currentColor;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Alert messages */\n.alert {\n  padding: var(--spacing-md) var(--spacing-lg);\n  border-radius: var(--border-radius);\n  margin-bottom: var(--spacing-lg);\n  border: 1px solid transparent;\n}\n\n.alert-error {\n  background-color: rgba(220, 53, 69, 0.1);\n  color: var(--danger);\n  border-color: rgba(220, 53, 69, 0.2);\n}\n\n.alert-success {\n  background-color: rgba(25, 135, 84, 0.1);\n  color: var(--success);\n  border-color: rgba(25, 135, 84, 0.2);\n}\n\n.alert-warning {\n  background-color: rgba(255, 193, 7, 0.1);\n  color: var(--warning);\n  border-color: rgba(255, 193, 7, 0.2);\n}\n\n/* Card component */\n.card {\n  background-color: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius-lg);\n  padding: var(--spacing-xl);\n  box-shadow: 0 2px 4px var(--shadow);\n  transition: box-shadow 0.2s ease, transform 0.2s ease;\n}\n\n.card:hover {\n  box-shadow: 0 4px 8px var(--shadow-hover);\n  transform: translateY(-2px);\n}\n\n.card-header {\n  margin-bottom: var(--spacing-lg);\n  padding-bottom: var(--spacing-md);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.card-title {\n  font-size: var(--font-size-lg);\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.card-content {\n  color: var(--text-secondary);\n}\n\n/* Dashboard layout */\n.dashboard {\n  padding: 0;\n}\n\n/* Tab Navigation */\n.tab-navigation {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 2rem;\n  border-bottom: 2px solid var(--border-color);\n  background: var(--bg-secondary);\n  border-radius: 12px 12px 0 0;\n  padding: 1rem 1rem 0 1rem;\n}\n\n.tab-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 1rem 1.5rem;\n  border: none;\n  background: transparent;\n  color: var(--text-secondary);\n  cursor: pointer;\n  border-radius: 8px 8px 0 0;\n  font-size: 1rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  border-bottom: 3px solid transparent;\n}\n\n.tab-button:hover {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n.tab-button.active {\n  background: var(--bg-primary);\n  color: var(--primary);\n  border-bottom: 3px solid var(--primary);\n}\n\n.tab-icon {\n  font-size: 1.2rem;\n}\n\n.tab-label {\n  font-weight: 600;\n}\n\n.tab-content {\n  background: var(--bg-secondary);\n  border-radius: 0 0 12px 12px;\n  padding: 2rem;\n  border: 1px solid var(--border-color);\n  border-top: none;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Welcome message */\n.welcome-message {\n  text-align: center;\n  padding: var(--spacing-xxl);\n}\n\n.welcome-title {\n  font-size: var(--font-size-xxxl);\n  font-weight: 700;\n  margin-bottom: var(--spacing-md);\n  color: var(--text-primary);\n}\n\n.welcome-subtitle {\n  font-size: var(--font-size-lg);\n  color: var(--text-secondary);\n  margin-bottom: var(--spacing-xl);\n}\n\n/* Form links */\n.form-links {\n  text-align: center;\n  margin-top: var(--spacing-lg);\n  padding-top: var(--spacing-lg);\n  border-top: 1px solid var(--border-color);\n}\n\n.form-links p {\n  color: var(--text-secondary);\n  font-size: var(--font-size-sm);\n}\n\n/* Mobile-First Responsive Design */\n\n/* Mobile Table Styles */\n@media (max-width: 768px) {\n  /* Header responsive */\n  .header {\n    padding: var(--spacing-md);\n  }\n  \n  .header-content {\n    flex-direction: column;\n    gap: var(--spacing-md);\n    align-items: stretch;\n  }\n  \n  .nav {\n    flex-direction: column;\n    gap: var(--spacing-sm);\n    align-items: stretch;\n  }\n  \n  .nav .btn {\n    width: 100%;\n    justify-content: center;\n  }\n  \n  /* Main content */\n  .main {\n    padding: var(--spacing-md);\n  }\n  \n  /* Welcome message */\n  .welcome-message {\n    padding: var(--spacing-lg);\n  }\n  \n  .welcome-title {\n    font-size: var(--font-size-xxl);\n  }\n  \n  .welcome-subtitle {\n    font-size: var(--font-size-base);\n  }\n  \n  /* Tab Navigation Mobile */\n  .tab-navigation {\n    flex-direction: column;\n    gap: 0;\n    padding: 0;\n    border-radius: var(--border-radius);\n    overflow: hidden;\n  }\n  \n  .tab-button {\n    border-radius: 0;\n    border-bottom: 1px solid var(--border-color);\n    padding: var(--spacing-lg);\n    justify-content: flex-start;\n  }\n  \n  .tab-button:last-child {\n    border-bottom: none;\n  }\n  \n  .tab-button.active {\n    border-bottom: 1px solid var(--border-color);\n    border-left: 4px solid var(--primary);\n  }\n  \n  .tab-content {\n    border-radius: var(--border-radius);\n    padding: var(--spacing-lg);\n  }\n  \n  /* Table Mobile Optimization */\n  .table-container {\n    overflow-x: auto;\n  }\n  \n  .table-filters {\n    flex-direction: column;\n    gap: var(--spacing-md);\n  }\n  \n  .filter-group {\n    min-width: auto;\n    width: 100%;\n  }\n  \n  .filter-clear {\n    width: 100%;\n    margin-top: var(--spacing-sm);\n  }\n  \n  /* Mobile Table - Card Layout */\n  .table-wrapper {\n    border: none;\n    border-radius: 0;\n  }\n  \n  .data-table {\n    display: none; /* Hide table on mobile */\n  }\n  \n  /* Mobile Card Layout */\n  .mobile-cards {\n    display: block;\n  }\n  \n  .mobile-card {\n    background: var(--bg-secondary);\n    border: 1px solid var(--border-color);\n    border-radius: var(--border-radius);\n    padding: var(--spacing-lg);\n    margin-bottom: var(--spacing-md);\n    box-shadow: 0 2px 4px var(--shadow);\n  }\n  \n  .mobile-card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: var(--spacing-md);\n    padding-bottom: var(--spacing-sm);\n    border-bottom: 1px solid var(--border-color);\n  }\n  \n  .mobile-card-title {\n    font-weight: 600;\n    color: var(--text-primary);\n    font-size: var(--font-size-lg);\n    margin: 0;\n    flex: 1;\n    margin-right: var(--spacing-md);\n  }\n  \n  .mobile-card-badges {\n    display: flex;\n    flex-direction: column;\n    gap: var(--spacing-xs);\n    align-items: flex-end;\n  }\n  \n  .mobile-card-content {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: var(--spacing-md);\n  }\n  \n  .mobile-card-field {\n    display: flex;\n    flex-direction: column;\n    gap: var(--spacing-xs);\n  }\n  \n  .mobile-card-field.full-width {\n    grid-column: 1 / -1;\n  }\n  \n  .mobile-card-label {\n    font-size: var(--font-size-xs);\n    font-weight: 600;\n    color: var(--text-secondary);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n  }\n  \n  .mobile-card-value {\n    font-size: var(--font-size-sm);\n    color: var(--text-primary);\n    word-break: break-word;\n  }\n  \n  .mobile-card-value.price {\n    font-weight: 600;\n    color: var(--primary);\n    font-size: var(--font-size-base);\n  }\n  \n  .mobile-card-actions {\n    margin-top: var(--spacing-md);\n    padding-top: var(--spacing-md);\n    border-top: 1px solid var(--border-color);\n    display: flex;\n    justify-content: flex-end;\n  }\n  \n  /* Pagination Mobile */\n  .pagination {\n    flex-direction: column;\n    gap: var(--spacing-md);\n    text-align: center;\n  }\n  \n  .pagination-controls {\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n  \n  .pagination-controls button {\n    padding: 0.5rem 0.75rem;\n    font-size: 0.8rem;\n    min-width: 44px; /* Accessibility: minimum touch target */\n  }\n  \n  .page-info {\n    font-size: 0.8rem;\n    padding: 0 0.5rem;\n  }\n  \n  /* Form responsive */\n  .form-container {\n    margin: var(--spacing-lg) auto;\n    padding: var(--spacing-lg);\n    max-width: none;\n  }\n  \n  .dashboard {\n    grid-template-columns: 1fr;\n    gap: var(--spacing-lg);\n  }\n  \n  /* Request Form Mobile */\n  .request-form-container {\n    padding: var(--spacing-md);\n  }\n  \n  .request-form-container .form-header h2 {\n    font-size: var(--font-size-xxl);\n  }\n  \n  .request-form-container .form-subtitle {\n    font-size: var(--font-size-base);\n  }\n  \n  .request-form-grid {\n    grid-template-columns: 1fr;\n    gap: var(--spacing-lg);\n  }\n  \n  .form-card {\n    padding: var(--spacing-lg);\n  }\n  \n  .form-card .card-title {\n    font-size: var(--font-size-lg);\n  }\n  \n  .providers-card {\n    grid-row: span 1; /* Reset row span on mobile */\n    grid-column: auto; /* Reset column positioning on mobile */\n  }\n  \n  .search-term-card {\n    grid-column: auto; /* Reset column positioning on mobile */\n    grid-row: auto; /* Reset row positioning on mobile */\n  }\n  \n  .additional-info-card {\n    grid-column: auto; /* Reset column positioning on mobile */\n    grid-row: auto; /* Reset row positioning on mobile */\n  }\n  \n  .providers-controls {\n    flex-direction: column;\n    gap: var(--spacing-md);\n  }\n  \n  .provider-search {\n    min-width: auto;\n    width: 100%;\n  }\n  \n  .select-all-btn {\n    width: 100%;\n  }\n  \n  .providers-grid {\n    grid-template-columns: 1fr;\n    gap: var(--spacing-md);\n    max-height: 300px;\n  }\n  \n  .provider-card {\n    padding: var(--spacing-md);\n  }\n  \n  .submit-btn {\n    width: 100%;\n    padding: var(--spacing-lg);\n    font-size: var(--font-size-lg);\n  }\n  \n  .requests-list {\n    grid-template-columns: 1fr;\n  }\n  \n  .request-item {\n    padding: var(--spacing-md);\n  }\n  \n  .request-content {\n    flex-direction: column;\n    align-items: stretch;\n    gap: var(--spacing-md);\n  }\n  \n  .request-actions {\n    justify-content: center;\n    margin-left: 0;\n    margin-top: var(--spacing-sm);\n  }\n  \n  .request-actions .btn {\n    width: 100%;\n    justify-content: center;\n    min-height: 44px;\n  }\n  \n  /* Legacy Request Form Mobile */\n  .request-form {\n    padding: var(--spacing-lg);\n  }\n  \n  .providers-header {\n    gap: var(--spacing-md);\n  }\n  \n  .form-actions {\n    margin-top: var(--spacing-lg);\n  }\n  \n  .previous-requests {\n    padding: var(--spacing-md);\n  }\n}\n\n/* Tablet Responsive Design */\n@media (min-width: 769px) and (max-width: 1024px) {\n  .request-form-container {\n    padding: var(--spacing-lg);\n  }\n  \n  .request-form-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: var(--spacing-lg);\n  }\n  \n  .providers-card {\n    grid-column: 1 / -1; /* Full width on tablet */\n    grid-row: span 1;\n  }\n  \n  .form-card .card-title {\n    font-size: var(--font-size-lg);\n  }\n  \n  .providers-grid {\n    max-height: 350px;\n  }\n}\n\n/* Desktop Table Display */\n@media (min-width: 769px) {\n  .mobile-cards {\n    display: none;\n  }\n  \n  .data-table {\n    display: table;\n  }\n}\n\n@media (max-width: 480px) {\n  .header {\n    padding: var(--spacing-sm);\n  }\n  \n  .main {\n    padding: var(--spacing-sm);\n  }\n  \n  .form-container {\n    margin: var(--spacing-md) auto;\n    padding: var(--spacing-md);\n  }\n  \n  .welcome-message {\n    padding: var(--spacing-md);\n  }\n  \n  .welcome-title {\n    font-size: var(--font-size-xl);\n  }\n  \n  .tab-content {\n    padding: var(--spacing-md);\n  }\n  \n  .mobile-card {\n    padding: var(--spacing-md);\n  }\n  \n  .mobile-card-content {\n    grid-template-columns: 1fr;\n  }\n  \n  .mobile-card-field {\n    grid-column: 1;\n  }\n}\n\n/* Landing Page Styles */\n.landing-page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.landing-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 var(--spacing-xl);\n  width: 100%;\n}\n\n/* Hero Section */\n.landing-hero {\n  background: linear-gradient(180deg, var(--bg-secondary) 20%, var(--bg-tertiary) 100%);\n  padding: var(--spacing-xxl) 0;\n  text-align: center;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.landing-hero-content {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.landing-logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-md);\n  margin-bottom: var(--spacing-xl);\n}\n\n.landing-logo-image {\n  height: 80px;\n  width: auto;\n  object-fit: contain;\n}\n\n.landing-title {\n  font-size: var(--font-size-xxxl);\n  font-weight: 700;\n  color: var(--primary);\n  margin: 0;\n}\n\n.landing-subtitle {\n  font-size: var(--font-size-xxl);\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 var(--spacing-lg) 0;\n}\n\n.landing-description {\n  font-size: var(--font-size-lg);\n  color: var(--text-secondary);\n  margin: 0 0 var(--spacing-xxl) 0;\n  line-height: 1.6;\n}\n\n.landing-actions {\n  display: flex;\n  gap: var(--spacing-lg);\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.btn-large {\n  padding: var(--spacing-lg) var(--spacing-xxl);\n  font-size: var(--font-size-lg);\n  min-height: 56px;\n}\n\n/* Features Section */\n.landing-features {\n  padding: var(--spacing-xxl) 0;\n  background: var(--bg-primary);\n}\n\n.section-title {\n  font-size: var(--font-size-xxl);\n  font-weight: 600;\n  color: var(--text-primary);\n  text-align: center;\n  margin: 0 0 var(--spacing-xxl) 0;\n}\n\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: var(--spacing-xl);\n}\n\n.feature-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius-lg);\n  padding: var(--spacing-xl);\n  text-align: center;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px var(--shadow);\n}\n\n.feature-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 25px var(--shadow-hover);\n}\n\n.feature-icon {\n  font-size: 3rem;\n  margin-bottom: var(--spacing-md);\n}\n\n.feature-title {\n  font-size: var(--font-size-lg);\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 var(--spacing-md) 0;\n}\n\n.feature-description {\n  color: var(--text-secondary);\n  margin: 0;\n  line-height: 1.6;\n}\n\n/* Call-to-Action Section */\n.landing-cta {\n  padding: var(--spacing-xxl) 0;\n  background: linear-gradient(0deg, var(--bg-tertiary) 0%, var(--bg-secondary) 100%);\n  text-align: center;\n  border-top: 1px solid var(--border-color);\n}\n\n.cta-title {\n  font-size: var(--font-size-xxl);\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 var(--spacing-lg) 0;\n}\n\n.cta-description {\n  font-size: var(--font-size-lg);\n  color: var(--text-secondary);\n  margin: 0 0 var(--spacing-xxl) 0;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.cta-actions {\n  display: flex;\n  gap: var(--spacing-lg);\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n/* Footer Section */\n.landing-footer {\n  background: var(--bg-secondary);\n  border-top: 1px solid var(--border-color);\n  padding: var(--spacing-xxl) 0 var(--spacing-lg) 0;\n  margin-top: auto;\n}\n\n.footer-content {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: var(--spacing-xl);\n  margin-bottom: var(--spacing-xl);\n}\n\n.footer-section {\n  text-align: left;\n}\n\n.footer-title {\n  font-size: var(--font-size-lg);\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 var(--spacing-md) 0;\n}\n\n.footer-description {\n  color: var(--text-secondary);\n  margin: 0;\n  line-height: 1.6;\n}\n\n.footer-contact {\n  color: var(--text-secondary);\n  margin: 0;\n  line-height: 1.8;\n}\n\n.footer-links {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm);\n}\n\n.footer-link {\n  color: var(--text-secondary);\n  text-decoration: none;\n  transition: color 0.2s ease;\n  background: none;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  text-align: left;\n}\n\n.footer-link:hover {\n  color: var(--primary);\n}\n\n.footer-link:focus {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n}\n\n.footer-bottom {\n  text-align: center;\n  padding-top: var(--spacing-lg);\n  border-top: 1px solid var(--border-color);\n  color: var(--text-muted);\n  margin: 0;\n}\n\n/* Mobile Responsive Styles for Landing Page */\n@media (max-width: 768px) {\n  .landing-container {\n    padding: 0 var(--spacing-md);\n  }\n  \n  .landing-hero {\n    padding: var(--spacing-xl) 0;\n  }\n  \n  .landing-logo {\n    flex-direction: column;\n    gap: var(--spacing-sm);\n  }\n  \n  .landing-logo-image {\n    height: 60px;\n  }\n  \n  .landing-title {\n    font-size: var(--font-size-xxl);\n  }\n  \n  .landing-subtitle {\n    font-size: var(--font-size-xl);\n  }\n  \n  .landing-description {\n    font-size: var(--font-size-base);\n  }\n  \n  .landing-actions {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .btn-large {\n    width: 100%;\n    max-width: 300px;\n  }\n  \n  .landing-features,\n  .landing-cta {\n    padding: var(--spacing-xl) 0;\n  }\n  \n  .section-title,\n  .cta-title {\n    font-size: var(--font-size-xl);\n  }\n  \n  .cta-description {\n    font-size: var(--font-size-base);\n  }\n  \n  .features-grid {\n    grid-template-columns: 1fr;\n    gap: var(--spacing-lg);\n  }\n  \n  .feature-card {\n    padding: var(--spacing-lg);\n  }\n  \n  .footer-content {\n    grid-template-columns: 1fr;\n    gap: var(--spacing-lg);\n  }\n  \n  .footer-section {\n    text-align: center;\n  }\n  \n  .footer-links {\n    align-items: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .landing-container {\n    padding: 0 var(--spacing-sm);\n  }\n  \n  .landing-hero {\n    padding: var(--spacing-lg) 0;\n  }\n  \n  .landing-logo-image {\n    height: 50px;\n  }\n  \n  .landing-title {\n    font-size: var(--font-size-xl);\n  }\n  \n  .landing-subtitle {\n    font-size: var(--font-size-lg);\n  }\n  \n  .feature-icon {\n    font-size: 2.5rem;\n  }\n  \n  .feature-card {\n    padding: var(--spacing-md);\n  }\n}\n\n/* Utility classes */\n.text-center {\n  text-align: center;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.mt-0 { margin-top: 0; }\n.mt-1 { margin-top: var(--spacing-sm); }\n.mt-2 { margin-top: var(--spacing-md); }\n.mt-3 { margin-top: var(--spacing-lg); }\n.mt-4 { margin-top: var(--spacing-xl); }\n\n.mb-0 { margin-bottom: 0; }\n.mb-1 { margin-bottom: var(--spacing-sm); }\n.mb-2 { margin-bottom: var(--spacing-md); }\n.mb-3 { margin-bottom: var(--spacing-lg); }\n.mb-4 { margin-bottom: var(--spacing-xl); }\n\n.d-flex {\n  display: flex;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.align-center {\n  align-items: center;\n}\n\n.gap-1 { gap: var(--spacing-sm); }\n.gap-2 { gap: var(--spacing-md); }\n.gap-3 { gap: var(--spacing-lg); }\n\n/* Focus styles for accessibility */\n.form-input:focus,\n.btn:focus,\n.theme-toggle:focus {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n}\n\n/* Smooth transitions */\n* {\n  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;\n}\n\n/* Table Container - styled as a card */\n.table-container {\n  width: 100%;\n  max-width: none;\n  background-color: var(--card-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: var(--shadow);\n}\n\n.table-header {\n  margin-bottom: 1.5rem;\n}\n\n.table-header h2 {\n  margin: 0 0 0.5rem 0;\n  color: var(--text-primary);\n  font-size: 1.5rem;\n}\n\n.table-subtitle {\n  color: var(--text-secondary);\n  margin: 0;\n  font-size: 0.9rem;\n}\n\n/* Table Filters */\n.table-filters {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n  align-items: end;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  min-width: 200px;\n}\n\n.filter-group label {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.filter-group input {\n  padding: 0.75rem;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 0.9rem;\n  transition: border-color 0.3s ease;\n}\n\n.filter-group input:focus {\n  outline: none;\n  border-color: var(--primary);\n}\n\n.filter-clear {\n  padding: 0.75rem 1rem;\n  background: var(--text-secondary);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: opacity 0.3s ease;\n}\n\n.filter-clear:hover {\n  opacity: 0.9;\n}\n\n/* Items per page select */\n.items-per-page-select {\n  padding: 0.75rem;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 0.9rem;\n  transition: border-color 0.3s ease;\n  cursor: pointer;\n  min-width: 80px;\n}\n\n.items-per-page-select:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);\n}\n\n.items-per-page-select:hover {\n  border-color: var(--primary);\n}\n\n/* Data Table */\n.table-wrapper {\n  overflow-x: auto;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  margin-bottom: 1rem;\n}\n\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.9rem;\n}\n\n.data-table th {\n  background: var(--bg-tertiary);\n  padding: 1rem 0.75rem;\n  text-align: left;\n  font-weight: 600;\n  color: var(--text-primary);\n  border-bottom: 2px solid var(--border-color);\n  white-space: nowrap;\n}\n\n.data-table th.sortable {\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.3s ease;\n}\n\n.data-table th.sortable:hover {\n  background: var(--bg-secondary);\n}\n\n.data-table td {\n  padding: 0.75rem;\n  border-bottom: 1px solid var(--border-color);\n  color: var(--text-primary);\n  vertical-align: top;\n}\n\n.data-table tbody tr:hover {\n  background: var(--bg-tertiary);\n}\n\n/* Table Cell Styles */\n.title-cell {\n  max-width: 250px;\n  word-wrap: break-word;\n}\n\n.type-badge {\n  display: inline-block;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  text-transform: capitalize;\n  background: var(--text-secondary);\n  color: white;\n}\n\n\n.keyword-badge {\n  display: inline-block;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  text-transform: capitalize;\n  background: var(--text-conformist);\n  color: white;\n}\n\n.provider-tag {\n  display: inline-block;\n  padding: 0.25rem 0.5rem;\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.price-cell {\n  font-weight: 600;\n  color: var(--primary);\n  white-space: nowrap;\n}\n\n.description-cell {\n  max-width: 200px;\n  word-wrap: break-word;\n  line-height: 1.4;\n}\n\n.url-link {\n  color: var(--primary);\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 0.9rem;\n}\n\n.url-link:hover {\n  text-decoration: underline;\n}\n\n/* PDF Table Specific */\n.file-name-cell {\n  max-width: 250px;\n  min-width: 180px;\n}\n\n.file-info {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.file-icon {\n  font-size: 1.5rem;\n}\n\n.file-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.file-ext {\n  color: var(--text-secondary);\n  font-weight: 600;\n}\n\n.page-count {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  font-size: 0.9rem;\n}\n\n.download-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  color: var(--primary);\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 0.9rem;\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.download-link:hover {\n  text-decoration: underline;\n}\n\n.download-link:focus {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n  border-radius: 2px;\n}\n\n.no-download {\n  color: var(--text-secondary);\n}\n\n/* File name link styles for diavgeia provider */\n.file-name-link {\n  color: var(--primary);\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.2s ease, text-decoration 0.2s ease;\n}\n\n.file-name-link:hover {\n  color: var(--primary-hover);\n  text-decoration: underline;\n}\n\n.file-name-link:focus {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n  border-radius: 2px;\n}\n\n/* Improved table column widths to prevent overlapping */\n.data-table th:nth-child(1) { /* Date column */\n  min-width: 100px;\n  max-width: 120px;\n}\n\n.data-table th:nth-child(2) { /* Query column */\n  min-width: 150px;\n  max-width: 200px;\n}\n\n.data-table th:nth-child(3) { /* File Name column */\n  min-width: 250px;\n  max-width: 300px;\n}\n\n.data-table th:nth-child(4) { /* Provider column */\n  min-width: 120px;\n  max-width: 150px;\n}\n\n.data-table th:nth-child(5) { /* Pages column */\n  min-width: 80px;\n  max-width: 100px;\n}\n\n.data-table th:nth-child(6) { /* Information column */\n  min-width: 200px;\n  max-width: 250px;\n}\n\n.data-table th:nth-child(7) { /* Download column */\n  min-width: 100px;\n  max-width: 120px;\n}\n\n/* Ensure proper word wrapping and overflow handling */\n.data-table td {\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  hyphens: auto;\n}\n\n.data-table .file-name-cell {\n  word-break: break-all;\n  overflow-wrap: anywhere;\n}\n\n/* Pagination */\n.pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 1rem;\n  padding: 1rem;\n  background: var(--bg-secondary);\n  border-radius: 8px;\n  border: 1px solid var(--border-color);\n}\n\n.pagination-info {\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n}\n\n.pagination-controls {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.pagination-controls button {\n  padding: 0.5rem 1rem;\n  border: 1px solid var(--border-color);\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  cursor: pointer;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n}\n\n.pagination-controls button:hover:not(:disabled) {\n  background: var(--primary);\n  color: white;\n}\n\n.pagination-controls button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.page-info {\n  font-size: 0.9rem;\n  color: var(--text-primary);\n  padding: 0 1rem;\n}\n\n/* Request Form Container */\n.request-form-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0; /* Remove padding to align with dashboard */\n}\n\n/* When RequestForm is inside tab-content, adjust spacing */\n.tab-content .request-form-container {\n  padding: 0;\n  max-width: none; /* Use full width of tab-content */\n}\n\n.request-form-container .form-header {\n  text-align: center;\n  margin-bottom: var(--spacing-xxl);\n}\n\n.request-form-container .form-header h2 {\n  font-size: var(--font-size-xxxl);\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: var(--spacing-md);\n}\n\n.request-form-container .form-subtitle {\n  font-size: var(--font-size-lg);\n  color: var(--text-secondary);\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n/* Request Form Grid Layout */\n.request-form-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: var(--spacing-lg);\n  margin-bottom: var(--spacing-xl);\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n/* Form Cards */\n.form-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius-lg);\n  padding: var(--spacing-lg);\n  box-shadow: 0 4px 6px var(--shadow);\n  transition: all 0.3s ease;\n  height: fit-content;\n  min-width: 0; /* Allow cards to shrink */\n}\n\n.form-card:hover {\n  box-shadow: 0 8px 25px var(--shadow-hover);\n  transform: translateY(-2px);\n}\n\n.form-card .card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: var(--spacing-lg);\n  padding-bottom: var(--spacing-md);\n  border-bottom: 2px solid var(--border-color);\n}\n\n.form-card .card-title {\n  font-size: var(--font-size-xl);\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n.form-card .card-content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-md);\n}\n\n/* Items per page container in card header */\n.items-per-page-container {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  margin-left: auto;\n}\n\n.items-per-page-container label {\n  font-size: var(--font-size-sm);\n  font-weight: 500;\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n\n.items-per-page-container .items-per-page-select {\n  padding: 0.5rem;\n  font-size: var(--font-size-sm);\n  min-width: 60px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius-sm);\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  transition: all 0.2s ease;\n}\n\n.items-per-page-container .items-per-page-select:hover {\n  border-color: var(--primary);\n}\n\n.items-per-page-container .items-per-page-select:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.1);\n}\n\n/* Mobile responsive for items per page container */\n@media (max-width: 768px) {\n  .items-per-page-container {\n    margin-left: 0;\n    margin-top: var(--spacing-sm);\n    width: 100%;\n    justify-content: flex-start;\n  }\n  \n  .items-per-page-container .items-per-page-select {\n    flex: 1;\n  }\n}\n\n/* Specific Card Styles */\n.search-term-card {\n  background: linear-gradient(135deg, var(--bg-secondary) 0%, var(--bg-tertiary) 100%);\n  grid-column: 3; /* Position in third column */\n  grid-row: 1; /* First row */\n}\n\n.providers-card {\n  background: linear-gradient(135deg, var(--bg-secondary) 0%, var(--bg-tertiary) 100%);\n  grid-column: 1 / 3; /* Span first two columns */\n  grid-row: 1 / 3; /* Span two rows */\n}\n\n.additional-info-card {\n  background: linear-gradient(135deg, var(--bg-secondary) 0%, var(--bg-tertiary) 100%);\n  grid-column: 3; /* Position in third column */\n  grid-row: 2; /* Second row */\n}\n\n.submit-card {\n  grid-column: 1 / -1; /* Full width */\n  background: var(--primary);\n  color: white;\n  text-align: center;\n  padding: var(--spacing-lg);\n}\n\n.submit-card .card-content {\n  align-items: center;\n}\n\n.previous-requests-card {\n  grid-column: 1 / -1; /* Full width */\n  background: linear-gradient(135deg, var(--bg-secondary) 0%, var(--bg-tertiary) 100%);\n}\n\n/* Enhanced Form Elements */\n.form-card .form-input,\n.form-card .form-textarea {\n  border: 2px solid var(--border-color);\n  border-radius: var(--border-radius);\n  padding: var(--spacing-md);\n  font-size: var(--font-size-base);\n  transition: all 0.3s ease;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n\n.form-card .form-input:focus,\n.form-card .form-textarea:focus {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);\n  transform: translateY(-1px);\n}\n\n.form-card .form-textarea {\n  resize: vertical;\n  min-height: 120px;\n}\n\n/* Provider Controls Enhancement */\n.providers-controls {\n  display: flex;\n  gap: var(--spacing-md);\n  margin-bottom: var(--spacing-lg);\n}\n\n.provider-search {\n  flex: 1;\n  border: 2px solid var(--border-color);\n  border-radius: var(--border-radius);\n  padding: var(--spacing-md);\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  transition: all 0.3s ease;\n}\n\n.provider-search:focus {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);\n}\n\n.select-all-btn {\n  padding: var(--spacing-md) var(--spacing-lg);\n  background: var(--primary);\n  color: white;\n  border: none;\n  border-radius: var(--border-radius);\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.select-all-btn:hover {\n  background: var(--primary-hover);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px var(--shadow-hover);\n}\n\n/* Enhanced Provider Grid */\n.providers-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--spacing-md);\n  max-height: 400px;\n  overflow-y: auto;\n  padding-right: var(--spacing-sm);\n}\n\n.providers-grid::-webkit-scrollbar {\n  width: 6px;\n}\n\n.providers-grid::-webkit-scrollbar-track {\n  background: var(--bg-tertiary);\n  border-radius: 3px;\n}\n\n.providers-grid::-webkit-scrollbar-thumb {\n  background: var(--primary);\n  border-radius: 3px;\n}\n\n.provider-card {\n  border: 2px solid var(--border-color);\n  border-radius: var(--border-radius);\n  padding: var(--spacing-md);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background: var(--bg-primary);\n}\n\n.provider-card:hover {\n  border-color: var(--primary);\n  box-shadow: 0 4px 8px var(--shadow);\n  transform: translateY(-1px);\n}\n\n.provider-card.selected {\n  border-color: var(--primary);\n  background: rgba(13, 110, 253, 0.1);\n  box-shadow: 0 0 0 1px var(--primary);\n}\n\n/* Enhanced Submit Button */\n.submit-btn {\n  padding: var(--spacing-lg) var(--spacing-xxl);\n  background: white;\n  color: var(--primary);\n  border: 2px solid white;\n  border-radius: var(--border-radius-lg);\n  font-size: var(--font-size-lg);\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-sm);\n  min-height: 60px;\n}\n\n.submit-btn:hover:not(:disabled) {\n  background: var(--bg-primary);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);\n}\n\n.submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Enhanced Messages */\n.error-message,\n.success-message {\n  padding: var(--spacing-md) var(--spacing-lg);\n  border-radius: var(--border-radius);\n  margin-bottom: var(--spacing-md);\n  font-weight: 500;\n  text-align: center;\n}\n\n.error-message {\n  background: rgba(220, 53, 69, 0.1);\n  color: var(--danger);\n  border: 2px solid rgba(220, 53, 69, 0.2);\n}\n\n.success-message {\n  background: var(--bg-primary);\n  color: var(--success);\n  border: 2px solid rgba(25, 135, 84, 0.2);\n}\n\n/* Previous Requests Enhancement */\n.requests-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: var(--spacing-md);\n}\n\n.request-item {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius);\n  padding: var(--spacing-lg);\n  transition: all 0.3s ease;\n}\n\n.request-item:hover {\n  box-shadow: 0 4px 8px var(--shadow);\n  transform: translateY(-1px);\n}\n\n/* Request Form Styles - Legacy Support */\n.request-form {\n  background: var(--bg-secondary);\n  padding: 2rem;\n  border-radius: 12px;\n  border: 1px solid var(--border-color);\n  margin-bottom: 2rem;\n}\n\n.form-textarea {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 1rem;\n  font-family: inherit;\n  transition: border-color 0.3s ease;\n  resize: vertical;\n  min-height: 80px;\n}\n\n.form-textarea:focus {\n  outline: none;\n  border-color: var(--primary);\n}\n\n.form-hint {\n  display: block;\n  margin-top: 0.25rem;\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n}\n\n.required {\n  color: var(--danger);\n}\n\n.optional {\n  color: var(--text-secondary);\n  font-weight: normal;\n}\n\n/* Provider Selection */\n.providers-header {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.providers-controls {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.provider-search {\n  flex: 1;\n  min-width: 200px;\n  padding: 0.75rem;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 0.9rem;\n  transition: border-color 0.3s ease;\n}\n\n.provider-search:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);\n}\n\n.select-all-btn {\n  padding: 0.75rem 1rem;\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.select-all-btn:hover {\n  background: var(--primary);\n  color: white;\n  border-color: var(--primary);\n}\n\n.providers-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n/* Ensure grid works on different screen sizes */\n@media (min-width: 1200px) {\n  .providers-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (min-width: 900px) and (max-width: 1199px) {\n  .providers-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (min-width: 769px) and (max-width: 899px) {\n  .providers-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.provider-selection-info {\n  margin-top: 0.5rem;\n}\n\n.provider-card {\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background: var(--bg-secondary);\n}\n\n.provider-card:hover {\n  border-color: var(--primary);\n  box-shadow: 0 2px 8px var(--shadow);\n}\n\n.provider-card.selected {\n  border-color: var(--primary);\n  background: var(--bg-tertiary);\n}\n\n.provider-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.provider-checkbox {\n  cursor: pointer;\n}\n\n.provider-name {\n  margin: 0;\n  font-size: 1rem;\n  color: var(--text-primary);\n}\n\n.provider-link {\n  margin-bottom: 0.5rem;\n}\n\n.provider-link a {\n  color: var(--primary);\n  text-decoration: none;\n  font-size: 0.9rem;\n}\n\n.provider-link a:hover {\n  text-decoration: underline;\n}\n\n.provider-properties {\n  color: var(--text-secondary);\n  font-size: 0.8rem;\n  line-height: 1.4;\n}\n\n/* Form Actions */\n.form-actions {\n  display: flex;\n  justify-content: center;\n  margin-top: 2rem;\n}\n\n.submit-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 1rem 2rem;\n  background: var(--primary);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.submit-btn:hover:not(:disabled) {\n  opacity: 0.9;\n  transform: translateY(-1px);\n}\n\n.submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.btn-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid transparent;\n  border-top: 2px solid currentColor;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* Previous Requests */\n.previous-requests {\n  background: var(--bg-secondary);\n  padding: 1.5rem;\n  border-radius: 12px;\n  border: 1px solid var(--border-color);\n}\n\n.previous-requests h3 {\n  margin: 0 0 1rem 0;\n  color: var(--text-primary);\n  font-size: 1.2rem;\n}\n\n.requests-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.request-item {\n  background: var(--bg-tertiary);\n  padding: 1rem;\n  border-radius: 8px;\n  border: 1px solid var(--border-color);\n}\n\n.request-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--spacing-md);\n}\n\n.request-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.request-term {\n  color: var(--text-primary);\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.request-providers,\n.request-status {\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n}\n\n.status-active {\n  color: var(--success);\n  font-weight: 500;\n}\n\n.status-inactive {\n  color: var(--danger);\n  font-weight: 500;\n}\n\n.request-actions {\n  flex-shrink: 0;\n  margin-left: var(--spacing-md);\n}\n\n.request-actions .btn {\n  padding: var(--spacing-sm) var(--spacing-md);\n  font-size: var(--font-size-sm);\n  min-height: 36px;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n}\n\n.request-actions .btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.request-actions .btn-spinner {\n  width: 12px;\n  height: 12px;\n  border: 1px solid transparent;\n  border-top: 1px solid currentColor;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* Loading and Error States */\n.loading-spinner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem;\n  gap: 1rem;\n}\n\n.loading-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255,255,255,0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid var(--border-color);\n  border-top: 4px solid var(--primary);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* Error and Success Messages */\n.error-message {\n  background: rgba(220, 53, 69, 0.1);\n  color: var(--danger);\n  padding: 1rem;\n  border-radius: 8px;\n  border: 1px solid rgba(220, 53, 69, 0.2);\n  margin: 1rem 0;\n}\n\n.error-message button {\n  margin-top: 0.5rem;\n  padding: 0.5rem 1rem;\n  background: var(--danger);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n/* .success-message {\n  background: rgba(25, 135, 84, 0.1);\n  color: var(--success);\n  padding: 1rem;\n  border-radius: 8px;\n  border: 1px solid rgba(25, 135, 84, 0.2);\n  margin: 1rem 0;\n} */\n\n/* No Data States */\n.no-data,\n.no-providers {\n  text-align: center;\n  padding: 3rem 1rem;\n  color: var(--text-secondary);\n}\n\n.no-data p,\n.no-providers p {\n  margin: 0.5rem 0;\n  font-size: 1.1rem;\n}\n\n.no-providers button {\n  margin-top: 1rem;\n  padding: 0.75rem 1.5rem;\n  background: var(--primary);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n/* Modal Dialog */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.modal-content {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius-lg);\n  padding: var(--spacing-xl);\n  max-width: 500px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  animation: modalSlideIn 0.3s ease-out;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.modal-content h3 {\n  margin: 0 0 var(--spacing-lg) 0;\n  font-size: var(--font-size-xl);\n  font-weight: 600;\n  color: var(--text-primary);\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n.modal-content p {\n  margin: 0 0 var(--spacing-md) 0;\n  color: var(--text-secondary);\n  font-size: var(--font-size-base);\n  line-height: 1.5;\n}\n\n.modal-content p:last-of-type {\n  margin-bottom: var(--spacing-lg);\n}\n\n.warning-text {\n  color: var(--danger);\n  font-weight: 500;\n  font-size: var(--font-size-sm);\n}\n\n.modal-actions {\n  display: flex;\n  gap: var(--spacing-md);\n  justify-content: flex-end;\n  margin-top: var(--spacing-xl);\n  padding-top: var(--spacing-lg);\n  border-top: 1px solid var(--border-color);\n}\n\n.modal-actions .btn {\n  min-width: 100px;\n}\n\n/* Enhanced Request Actions */\n.request-actions {\n  display: flex;\n  gap: var(--spacing-sm);\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.request-actions .btn {\n  margin: 0;\n  font-size: var(--font-size-sm);\n  padding: var(--spacing-sm) var(--spacing-md);\n  min-height: 36px;\n}\n\n/* Delete Button Styling */\n.delete-btn {\n  background: var(--danger);\n  color: white;\n  border: none;\n  border-radius: var(--border-radius);\n  padding: var(--spacing-sm) var(--spacing-md);\n  cursor: pointer;\n  font-size: var(--font-size-base);\n  font-weight: 500;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 36px;\n  min-width: 36px;\n}\n\n.delete-btn:hover:not(:disabled) {\n  background: var(--danger-hover);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px var(--shadow-hover);\n}\n\n.delete-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.delete-btn:focus {\n  outline: 2px solid var(--danger);\n  outline-offset: 2px;\n}\n\n/* Mobile Delete Button Styling */\n.mobile-delete-btn {\n  background: var(--danger);\n  color: white;\n  border: none;\n  border-radius: var(--border-radius);\n  padding: var(--spacing-sm) var(--spacing-md);\n  cursor: pointer;\n  font-size: var(--font-size-base);\n  font-weight: 500;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 44px; /* Accessibility: minimum touch target */\n  min-width: 44px;\n}\n\n.mobile-delete-btn:hover:not(:disabled) {\n  background: var(--danger-hover);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px var(--shadow-hover);\n}\n\n.mobile-delete-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.mobile-delete-btn:focus {\n  outline: 2px solid var(--danger);\n  outline-offset: 2px;\n}\n\n/* Success Message Styling */\n.success-message {\n  background: rgba(25, 135, 84, 0.1);\n  color: var(--success);\n  padding: 1rem;\n  border-radius: 8px;\n  border: 1px solid rgba(25, 135, 84, 0.2);\n  margin: 1rem 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.success-message button {\n  background: var(--success);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 0.5rem 1rem;\n  cursor: pointer;\n  font-size: var(--font-size-sm);\n  transition: all 0.2s ease;\n}\n\n.success-message button:hover {\n  background: var(--success-hover);\n}\n\n/* Bot Detail Card Styles */\n.bot-detail-card {\n  background: linear-gradient(135deg, var(--bg-secondary) 0%, var(--bg-tertiary) 100%);\n  border: 2px solid var(--border-color);\n  border-radius: var(--border-radius-lg);\n  padding: var(--spacing-xl);\n  margin-bottom: var(--spacing-xl);\n  box-shadow: 0 4px 6px var(--shadow);\n  transition: all 0.3s ease;\n}\n\n.bot-detail-card:hover {\n  box-shadow: 0 8px 25px var(--shadow-hover);\n  transform: translateY(-2px);\n  border-color: var(--primary);\n}\n\n.bot-detail-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: var(--spacing-lg);\n  padding-bottom: var(--spacing-md);\n  border-bottom: 2px solid var(--border-color);\n  flex-wrap: wrap;\n  gap: var(--spacing-md);\n}\n\n.bot-detail-title {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n  flex: 1;\n  min-width: 0;\n}\n\n.bot-detail-title h3 {\n  margin: 0;\n  font-size: var(--font-size-xxl);\n  font-weight: 700;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.bot-detail-icon {\n  font-size: 2rem;\n  color: var(--primary);\n  flex-shrink: 0;\n}\n\n.bot-status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n  padding: var(--spacing-sm) var(--spacing-md);\n  background: var(--success);\n  color: white;\n  border-radius: var(--border-radius);\n  font-size: var(--font-size-sm);\n  font-weight: 600;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.bot-status-badge.active {\n  background: var(--success);\n}\n\n.bot-status-badge i {\n  font-size: 0.6rem;\n  animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.bot-detail-stats {\n  display: flex;\n  gap: var(--spacing-lg);\n  flex-wrap: wrap;\n}\n\n.bot-stat-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-xs);\n  padding: var(--spacing-md);\n  background: var(--bg-primary);\n  border-radius: var(--border-radius);\n  border: 1px solid var(--border-color);\n  min-width: 120px;\n  transition: all 0.3s ease;\n}\n\n.bot-stat-item:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px var(--shadow-hover);\n  border-color: var(--primary);\n}\n\n.bot-stat-item i {\n  font-size: var(--font-size-xl);\n  color: var(--primary);\n}\n\n.bot-stat-label {\n  font-size: var(--font-size-xs);\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  text-align: center;\n}\n\n.bot-stat-value {\n  font-size: var(--font-size-lg);\n  font-weight: 700;\n  color: var(--text-primary);\n  text-align: center;\n}\n\n.bot-detail-content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-lg);\n}\n\n.bot-detail-section {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm);\n}\n\n.bot-detail-label {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  font-size: var(--font-size-sm);\n  font-weight: 700;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.bot-detail-label i {\n  color: var(--primary);\n  font-size: var(--font-size-base);\n}\n\n.bot-tags-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--spacing-sm);\n}\n\n.bot-property-tag {\n  display: inline-block;\n  padding: var(--spacing-sm) var(--spacing-md);\n  background: var(--primary);\n  color: white;\n  border-radius: var(--border-radius);\n  font-size: var(--font-size-sm);\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.bot-property-tag:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px var(--shadow-hover);\n}\n\n.bot-search-tag {\n  display: inline-block;\n  padding: var(--spacing-sm) var(--spacing-md);\n  background: var(--success);\n  color: white;\n  border-radius: var(--border-radius);\n  font-size: var(--font-size-sm);\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.bot-search-tag:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px var(--shadow-hover);\n}\n\n/* Bot Detail Card Mobile Responsiveness */\n@media (max-width: 768px) {\n  .bot-detail-card {\n    padding: var(--spacing-lg);\n    margin-bottom: var(--spacing-lg);\n  }\n\n  .bot-detail-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: var(--spacing-md);\n  }\n\n  .bot-detail-title {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--spacing-sm);\n  }\n\n  .bot-detail-title h3 {\n    font-size: var(--font-size-xl);\n    white-space: normal;\n    word-break: break-word;\n  }\n\n  .bot-visit-link {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .bot-tags-container {\n    gap: var(--spacing-xs);\n  }\n\n  .bot-property-tag,\n  .bot-search-tag {\n    font-size: var(--font-size-xs);\n    padding: var(--spacing-xs) var(--spacing-sm);\n  }\n}\n\n@media (max-width: 480px) {\n  .bot-detail-card {\n    padding: var(--spacing-md);\n  }\n\n  .bot-detail-icon {\n    font-size: 1.5rem;\n  }\n\n  .bot-detail-title h3 {\n    font-size: var(--font-size-lg);\n  }\n\n  .bot-status-badge {\n    font-size: var(--font-size-xs);\n    padding: var(--spacing-xs) var(--spacing-sm);\n  }\n}\n\n@media (max-width: 768px) {\n  .modal-content {\n    margin: var(--spacing-md);\n    padding: var(--spacing-lg);\n    width: calc(100% - 2rem);\n  }\n  \n  .modal-actions {\n    flex-direction: column;\n    gap: var(--spacing-sm);\n  }\n  \n  .modal-actions .btn {\n    width: 100%;\n  }\n  \n  .request-actions {\n    flex-direction: column;\n    gap: var(--spacing-xs);\n  }\n  \n  .request-actions .btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
